var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.77,
    y: 318.09,
    width: 124.73,
    height: 124.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632,443.32H506.27V317.59H632Zm-124.73-1H631V318.59H507.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 631.5,
    cy: 318.09,
    r: 15.44,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.99,
    y: 309.32,
    width: 3.02,
    height: 17.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.99,
    y: 309.32,
    width: 3.02,
    height: 17.53,
    transform: "translate(313.41 949.59) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.76,442.82h72.39c-5-18.13-13.33-40.07-26.73-56.61-.67-.85-1.36-1.67-2.07-2.48l-.05-.05a9.48,9.48,0,0,0-2.14-1.78,12.18,12.18,0,0,0-2.14-1.06c-.42-.17-.86-.32-1.29-.45a24.19,24.19,0,0,0-6.57-.93c-4.73,0-9,1.06-9.92,2.35a3.92,3.92,0,0,0-.33.5c-.27.38-.53.78-.77,1.18a1.74,1.74,0,0,0-.15.26,6.26,6.26,0,0,0-.34.55c-.41.68-.82,1.39-1.22,2.13s-.94,1.78-1.41,2.72c-.15.32-.31.64-.47,1l-.49,1.05a192.77,192.77,0,0,0-8.76,23.67.19.19,0,0,0,0,.07c0,.09-.06.16-.08.23-.14.43-.26.87-.39,1.29a.14.14,0,0,0,0,.06c0,.09,0,.17-.07.24-.19.62-.37,1.23-.55,1.84-1.1,3.72-2.16,7.49-3.15,11.24q-1.12,4.24-2.15,8.42c-.06.23-.12.46-.17.7l-.18.69a1.24,1.24,0,0,1,0,.16c-.1.47-.22,1-.34,1.42S538.88,442.28,538.76,442.82Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.73,442.82h26.66c.16-.66.32-1.35.5-2.05.07-.31.14-.63.23-.95a1.6,1.6,0,0,1,0-.21c.62-2.48,1.36-5.16,2.24-8,2.25-7.12,5.34-15.53,8.29-23.16.86-2.25,1.71-4.44,2.53-6.51.2-.52.4-1,.6-1.54l.47-1.2c1-2.52,1.91-4.8,2.69-6.74s1.48-3.71,1.92-4.85c.09-.23.17-.45.24-.67.7-2.16.19-2.93-1-2.77a3.7,3.7,0,0,0-.49.11,6.82,6.82,0,0,0-1,.41,17.08,17.08,0,0,0-1.59.9.75.75,0,0,0-.15.09l-.21.13a46.45,46.45,0,0,0-7.82,6.8c-5,5.41-13.66,17.08-21.83,29.65a4.53,4.53,0,0,0-.3.46C521.33,429.45,517.13,436.42,513.73,442.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.5,442.82H541c.19-.68.38-1.38.58-2.09a.43.43,0,0,0,0-.05c.06-.24.13-.49.2-.74,2.35-8.39,5.23-18.47,7-23.3.16-.5.37-1,.55-1.53.92-2.49,2.19-5.75,3.59-9.28l0,0c.43-1.08.86-2.17,1.31-3.28.18-.47.38-.95.56-1.43l.47-1.14a1.77,1.77,0,0,1,.06-.17h0l2.81-6.95,2.2-5.37,1.94-4.74a17.58,17.58,0,0,0-3.12.78l-.22.08c-.41.15-.82.3-1.22.49-.56.24-1.14.52-1.72.84-3.17,1.73-6.75,4.64-11.42,9.54-3.55,3.73-12.13,14.57-20.44,27.08-.34.5-.67,1-1,1.52A207,207,0,0,0,511.5,442.82Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.13,442.82H541c.19-.68.38-1.38.58-2.09a.43.43,0,0,0,0-.05c.06-.24.13-.49.2-.74,2.35-8.39,5.23-18.47,7-23.3.16-.5.37-1,.55-1.53.92-2.49,2.19-5.75,3.59-9.28l-1.19,2.64L542,429.81l-3.74,8.26-.68,1.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583,388.69c-.32,2.82.56,7.53,2,12.44.81,2.72,1.91,6.07,3.16,9.73,1.45,4.24,3.11,8.9,4.79,13.51,1.54,4.25,4.49,12.17,6.83,18.45H628.1c-1.33-2.55-2.75-5.16-4.26-7.76-.11-.21-.24-.42-.35-.62A286.18,286.18,0,0,0,605,406.5l-.57-.76c-6-7.87-11.6-14.28-15.72-17.78a9.56,9.56,0,0,0-2.72-1.75,1.8,1.8,0,0,0-2.69,1.2A4.66,4.66,0,0,0,583,388.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.21,389.21c0,.12.07.24.11.35,1,3.44,2.67,7.62,3.81,11.18,1.37,4.31,3.9,11.39,6.67,18.93,3,8.14,6.27,16.81,8.68,23.15h30c-1.42-2.64-2.94-5.34-4.53-8l-.24-.41A317.42,317.42,0,0,0,605.64,406l-.58-.76c-3.17-4.19-6.15-7.85-8.68-10.72-4.36-4.93-9.18-9-12.55-10.83-.43-.24-.84-.45-1.2-.61-1.21-.52-2.13-.65-2.65-.33a1.2,1.2,0,0,0-.46.55,3.78,3.78,0,0,0-.19,1.87,21.32,21.32,0,0,0,.76,3.63Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.25,442.82h4c-.22-.08-.44-.13-.64-.19h0a13,13,0,0,0-2.9-.56h0l-.06.12-.12.19Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.37,415.94c.57,1.28,1.14,2.57,1.82,3.8.47.84,1,1.68,1.48,2.5q2.39,7.11,5,14.14c.81,2.15,1.59,4.3,2.42,6.44h1.13c-3.76-10.69-7.62-21.36-11.79-31.91,0-.1-.15-.11-.24-.05a.13.13,0,0,0-.07.15q1.3,4.35,2.71,8.66l-.09-.17c-.64-1.27-1.38-2.46-2.13-3.67A.12.12,0,0,0,588.37,415.94Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.75,395.69c4.7,1.33,13.15-5.57,16.63-11.3.23-.4-.2-4.67-.48-9.89-.16-3.16-.26-6.69-.12-9.92l-20.45,4a51.57,51.57,0,0,1,1.41,12.47,6.77,6.77,0,0,1-.19,1.32c0,.06,0,.13,0,.22C559,385.13,558.21,394.4,562.75,395.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.5,382.63a2.66,2.66,0,0,0-.07.45c12.31-1.38,16.64-7.14,19.31-12.56,0-2,0-4,0-5.94l-20.45,4a51.13,51.13,0,0,1,1.41,12.48,6.87,6.87,0,0,1-.2,1.32S559.52,382.54,559.5,382.63Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.41,340.66c2.44,7.1-.63,28-5.58,32.77-7.16,7-19.26,8-25.27-.68-5.82-8.43-1.33-35.56,4.22-40C564,326.31,578.81,330.16,582.41,340.66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.48,353.23c0-.05.1.09.09.14-.24,1.4-.29,3.05.92,3.7,0,0,0,.09,0,.07C565.94,356.7,566,354.52,566.48,353.23Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568,351.94c2.28.15,1.81,4.72-.3,4.58S566,351.82,568,351.94Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.83,352.54c0-.05-.12.06-.12.12-.1,1.41-.46,3-1.78,3.36,0,0,0,.08,0,.08C557.51,356,558,353.9,557.83,352.54Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.72,350.94c-2.26-.41-2.9,4.13-.81,4.51S558.61,351.28,556.72,350.94Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.61,349.46a17.66,17.66,0,0,1-1.75-.69,3.06,3.06,0,0,1-1.66-1,1,1,0,0,1,.2-1.17,2.4,2.4,0,0,1,2.43-.17,3.57,3.57,0,0,1,2,1.6A1,1,0,0,1,569.61,349.46Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.17,348.11a16.72,16.72,0,0,0,1.86-.29,3,3,0,0,0,1.85-.65,1,1,0,0,0,.06-1.18,2.41,2.41,0,0,0-2.34-.7,3.56,3.56,0,0,0-2.28,1.13A1,1,0,0,0,555.17,348.11Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.6,366.36c-.37.29-.75.71-1.27.7a3.73,3.73,0,0,1-1.48-.51c-.05,0-.1,0-.07.07a1.9,1.9,0,0,0,1.71.95,1.5,1.5,0,0,0,1.24-1.14C565.76,366.35,565.66,366.31,565.6,366.36Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.55,362a4.79,4.79,0,0,1-3.43,1.81,5.67,5.67,0,0,1-1.74-.1,1.3,1.3,0,0,1-.33-.07,1.92,1.92,0,0,1-.3-.08.35.35,0,0,1-.25-.34h0a.8.8,0,0,1,0-.15h0v-.12c.09-1.09.36-2.74.36-2.74-.42.16-2.54.87-2.45.3.77-4.68,1.62-9.88,3.36-14.37.05-.15.29-.09.26.06-.56,4.52-1.91,8.92-2.54,13.46a8.55,8.55,0,0,1,2.35-.46c.15.06-.59,3.17-.59,3.66v.06c1.81.42,3.24,0,5.14-1C564.55,361.76,564.65,361.87,564.55,362Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.25,351.32c-1.82-4-.13-11.17-2.38-12.82-4.87-3.58-13.27,5-19.56,5.7-6.1.64-8.52-3.08-7.91-8.14s4.49-8.79,11.23-10.49c7-1.76,13.71.46,17.44,2.36,0,0-1.78-2.32-1.28-3.15s3.72,1.26,4.73,2.18a9.21,9.21,0,0,1,1.78,2.79,9.86,9.86,0,0,1,2.76-.56,5.84,5.84,0,0,1,3.77,1.26c.15.36-2,.86-3.59,1.09,0,0,3.28,3.57,3.54,6.87s-3.32,19.47-4.53,19.76C580.69,358.54,577,353,576.25,351.32Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.6,331.2c-.06,0-.13.06-.07.1a10.47,10.47,0,0,1,3.76,4.34,13,13,0,0,1,.74,6.78c-.54,4.43-2.27,8.56-3.71,12.74,0,.12.16.2.21.08,1.82-4.33,3.63-9,4-13.73C587.86,337.49,586.5,333,582.6,331.2Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,336.88a14.9,14.9,0,0,0-5.49.9A21.57,21.57,0,0,0,564,340.6c-3.28,2.22-6.94,4.06-11,4.21a0,0,0,0,0,0,.08,18.58,18.58,0,0,0,10.27-3.29,47.36,47.36,0,0,1,4.65-3.08,19.33,19.33,0,0,1,6.06-1.31A.17.17,0,0,0,574,336.88Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.14,326.57a29.51,29.51,0,0,0-8.08-1.82,23.12,23.12,0,0,0-7.91.51c-4.45,1.18-8.32,4.47-8.92,9.21a10,10,0,0,0,1.62,7,.13.13,0,0,0,.21-.14,10.24,10.24,0,0,1,1.13-12.21c3.39-3.58,8.57-4.35,13.26-4.06a41.32,41.32,0,0,1,8.68,1.58S571.16,326.57,571.14,326.57Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.87,355.52a6.1,6.1,0,0,0,4.56,5.26,6,6,0,0,0,1.5.19,6.11,6.11,0,0,0,5.91-4.6,6.52,6.52,0,0,0,.18-1.74,5.41,5.41,0,0,0-.1-.82,6.09,6.09,0,0,0-11.79-.8c0,.12-.08.24-.11.37a4.76,4.76,0,0,0-.1.52A5.53,5.53,0,0,0,561.87,355.52Zm.94-1.94a5.27,5.27,0,0,1,5.11-4,5,5,0,0,1,1.31.16,5.28,5.28,0,1,1-6.42,3.82Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.64,359.26l.4,0a4.31,4.31,0,0,0,3.31-1.79,7.44,7.44,0,0,0,1.51-3.76c0-.14,0-.28,0-.41a7.57,7.57,0,0,0,0-.95,9.29,9.29,0,0,0-.16-1.21,6.75,6.75,0,0,0-.67-1.81,3.81,3.81,0,0,0-6.47-.75,7.36,7.36,0,0,0-1.77,4.08C549.45,356,551.16,359,553.64,359.26Zm-3-6.49a6.41,6.41,0,0,1,1.56-3.62,3.32,3.32,0,0,1,2.43-1.21H555a3.29,3.29,0,0,1,2.4,1.79,6.17,6.17,0,0,1,.61,1.67,7.14,7.14,0,0,1,.08,2.22,7.89,7.89,0,0,1-.27,1.3,1.18,1.18,0,0,1-.07.2c-.07.22-.16.42-.25.63-.79,1.75-2.22,2.86-3.72,2.69C551.71,358.21,550.32,355.67,550.66,352.77Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.14,354.1l.59-.56c-.83-.88-2.83-2.16-4.49-.75l.52.62C560.25,352.15,562.06,354,562.14,354.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.71,358.88l.77-.28c-.14-.36-1.37-3.49-3.14-4s-11.41-.79-11.87-.8l0,.81c3.14.07,10.39.41,11.67.78S587.39,358,587.71,358.88Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.75,357.86s4.59-6.78,7.66-5.15-.31,11.41-3.87,12.79a3.64,3.64,0,0,1-4.9-1.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.37,355.49c.06,0,.07.07,0,.09-2.49,1.06-3.77,3.4-4.66,5.82a2,2,0,0,1,3-.59c.07.05,0,.15-.06.14a2.23,2.23,0,0,0-2.45.81,10.79,10.79,0,0,0-1.15,2c-.12.23-.52.11-.44-.15,0,0,0,0,0-.06C578.53,360.37,581,355.86,584.37,355.49Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.01,
    y: 111.65,
    width: 124.73,
    height: 124.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.25,236.88H129.51V111.15H255.25Zm-124.74-1H254.25V112.15H130.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.75,
    cy: 111.65,
    r: 15.44,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.24,
    y: 102.88,
    width: 3.02,
    height: 17.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.24,
    y: 102.88,
    width: 3.02,
    height: 17.53,
    transform: "translate(143.1 366.39) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,180a.62.62,0,0,0,.43.69l2.49.41c2.82-5.62,5.69-10,4.88-8.27a30.64,30.64,0,0,0-2.44,8.66c1.1.18,3.65.55,4.92.74,3-10.1,6.22-17.48,5.83-15.14-1.56,9.43-1.3,12.54-1,15.87,11.88,1.73,27.48,3.84,38.79,5.12,1.87-5.56,3.62-11.6,3.77-11.15,1.23,3.36,1.19,8.07.87,11.66,3.6.38,6.49.62,8.26.68,0,0,1.31-4.7,1.59-6.26a33.26,33.26,0,0,0-.08-12.1c-.81-4.11-2.53-7.83-4.14-11.64a.59.59,0,0,0,0-.08l0,0a34.69,34.69,0,0,1-2.28-7.72s0,0,0-.06a32.72,32.72,0,0,1-.37-5.79c.17-7.07-3.19-13.54-9.6-16.05-11.31-13-24.28-9.28-28.94-.65-.45.85-.9,1.82-1.36,2.88v0c-1.68,3.93-3.34,9.09-4.8,13a0,0,0,0,1,0,0s0,0,0,0h0a40.08,40.08,0,0,1-1.94,4.56C169.29,156.53,161.68,160,158.36,180Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,131.79c4.11,2.69,6.44,6.25,6.6,11.45.1,3,0,6,.88,8.89a31.29,31.29,0,0,0,4.23,8.18c2.68,4.09,4.45,8.08,4.42,13.15s-.86,11.16-3.05,15.76c0,0-.05,0,0,0,1.87-4.69,2.57-11.38,2.21-16.53-.4-5.65-3.2-9.47-6-14a23.31,23.31,0,0,1-3.62-11.82c-.07-2.57.23-5.2-.56-7.69-.93-3-3.18-5-5.43-6.87A.3.3,0,0,1,212.92,131.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.12,156.65c3.45-3.68,7-6.75,9.25-11.52,2.07-4.33,3.48-9,5.58-13.33a.06.06,0,1,1,.11,0c-3.35,7.72-4.64,15.73-10.46,21.93-3.16,3.37-6.29,6.47-8.57,10.66a39,39,0,0,0-4.33,14.15.13.13,0,1,1-.25,0A32.45,32.45,0,0,1,165.12,156.65Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.7,129.85c-1.3-.73-1.36-8.64,4.29-11.49s11.46,2.39,7.72,8.25C219.35,130.32,212.44,131.41,209.7,129.85Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.14,119.05a8.73,8.73,0,0,1,2.13,5.35,5.24,5.24,0,0,1-2.34,4.71,10.72,10.72,0,0,1-5.42,1.65,16.19,16.19,0,0,1-2.95-.12,8,8,0,0,1-2.86-.79,7.18,7.18,0,0,0,2.75,1.33,13.23,13.23,0,0,0,3.07.44,10.29,10.29,0,0,0,6-1.59,5.85,5.85,0,0,0,2.57-5.69A7.68,7.68,0,0,0,221.14,119.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.22,236.38h29.54c4-10,11.51-28.12,17.67-42.46,5-11.58,2.77-13.65-1.09-12.32-2.94,1-6.86,4.05-9.28,6.36C164.45,200,149.82,219.68,140.22,236.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.75,236.38h31.56c5.07-12.19,14.89-35.44,18.31-44.29,3-7.71,2.39-12-1.84-11-2.21.49-5.41,2.4-9.61,6C167.81,195.06,149.7,217.64,138.75,236.38Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.41,226.23l0,.14c.08.37.18.73.27,1.08s.28,1,.43,1.42a.14.14,0,0,0,0,.07,34.42,34.42,0,0,0,2.65,6.14l-.19,1.3h64.31c-4.91-19.22-12.58-40.08-19.5-50.88-4.73-7.4-18.37-12.89-28.12-1.31-2.09,2.48-5,6.73-8.16,11.33v0c-.15.2-.28.4-.43.62l-.84,1.26c-.08.11-.17.24-.24.36-4.88,7.29-9.58,15.22-10.51,19.7A20.89,20.89,0,0,0,164.41,226.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,232.51a48.06,48.06,0,0,1,6.19,1.11c3.13.81,6.22,1.74,9.28,2.76h2.11c-2.45-.91-4.94-1.81-6.57-2.26a42.77,42.77,0,0,0-11-1.83A.11.11,0,0,0,178,232.51Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42,234.18a34.15,34.15,0,0,1,11.56,1c.05,0,0,.09,0,.08-1.92-.23-3.82-.45-5.75-.61s-3.87-.26-5.8-.39A.06.06,0,0,1,171.42,234.18Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.31,225.11a22.07,22.07,0,0,0,1.43,5.37,20.85,20.85,0,0,0,2.58,4.72c0,.39-.11.79-.17,1.18h.95c.06-.41.13-.83.19-1.23l0-.19-.13-.17a23.33,23.33,0,0,1-3-5.85.14.14,0,0,1,0-.07c-.16-.46-.31-1-.43-1.42a10.65,10.65,0,0,1-.27-1.08l0-.14c-.08-.42-.16-.83-.22-1.24a19.1,19.1,0,0,1,0-5.34,23,23,0,0,1,1.35-5.17,66.62,66.62,0,0,1,4.81-9.73c1.36-2.37,2.81-4.69,4.32-7,.07-.12.16-.25.24-.36l.84-1.26c.15-.22.28-.42.43-.62-1.83,2.34-3.55,4.79-5.18,7.29-.14.22-.29.43-.43.66s-.43.66-.64,1a67.64,67.64,0,0,0-5.11,9.72,21.77,21.77,0,0,0-1.48,5.35A20.3,20.3,0,0,0,163.31,225.11Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,197.55a10,10,0,0,0-.95,1.47,13.41,13.41,0,0,0-.75,1.58,12.41,12.41,0,0,0-.85,3.39c.24-.54.44-1.08.66-1.61l.64-1.6C172.2,199.71,172.64,198.65,173,197.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.08,194.24c3.88,15.06,11.71,37.19,13.15,42.14h30.21c-6.17-13.21-20.88-36.11-31.74-48.72a16,16,0,0,0-2.27-2.16C207,181.23,199.73,181.24,203.08,194.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,191.12c.38,2.32,1.19,5.73,2.24,9.71l0,.1c.33,1.21.68,2.48,1,3.78.09.29.16.57.24.86,2.93,10.32,6.89,22.82,9.43,30.81h33c-6.49-13.4-20.55-36.18-33.07-49.69a18.66,18.66,0,0,0-4.65-3.78C204.77,179.93,200.63,182.85,202,191.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.22,200.93c.27,1.16.57,2.31.88,3.47h0c.11.35.21.71.3,1.07.93,3.28,1.93,6.53,2.9,9.79l4.38,14.36c.66,2.24,1.36,4.52,1.9,6.75h1c-.54-2.43-1.29-4.69-2-7-1.51-4.78-3-9.55-4.63-14.29L206.55,208C205.76,205.61,204.91,203.29,204.22,200.93Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.67,202.31a7,7,0,0,0,.77,1.89,6.64,6.64,0,0,0,.57.85,3.26,3.26,0,0,0,.76.72c-.3-.63-.57-1.23-.91-1.81A9.45,9.45,0,0,0,203.67,202.31Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.66,180.87c-.39,1.35-7.39,9.88-13.62,9.26-2-.21-1.4-11.34-1.4-11.34l-.14-.83-2-11.65,14-8,2-1s.33,3.22.69,7.24c0,.19,0,.37.06.57s.05.44.07.66c.06.6.12,1.21.17,1.82s.08.92.1,1.41.06,1,.1,1.46A76.4,76.4,0,0,1,203.66,180.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.23,164.54A23.69,23.69,0,0,1,188.5,178l-2-11.65,14-8,2-1S202.87,160.52,203.23,164.54Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.94,145.79c-4.22,20.3,7.47,25.12,11.85,26,4,.82,17.62,3.11,23.91-16.65s-1.82-28.14-10.82-30.5S176.15,125.48,171.94,145.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.79,141a13.67,13.67,0,0,0,1.43-.05,2.35,2.35,0,0,0,1.45-.34.74.74,0,0,0,.15-.89,1.83,1.83,0,0,0-1.71-.72,2.73,2.73,0,0,0-1.82.65A.79.79,0,0,0,178.79,141Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.75,144.11a12.63,12.63,0,0,1-1.33-.52,2.31,2.31,0,0,1-1.26-.8.73.73,0,0,1,.15-.88,1.83,1.83,0,0,1,1.85-.13,2.73,2.73,0,0,1,1.51,1.22A.79.79,0,0,1,192.75,144.11Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.16,148.51s.09.09.08.14c-.31,1.38-.44,3,.73,3.71,0,0,0,.09,0,.08C188.45,151.93,188.64,149.76,189.16,148.51Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.67,147.3c2.27.26,1.58,4.77-.52,4.52S188.78,147.08,190.67,147.3Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,147.67c.36.32.67.83,1.14,1s1-.27,1.46-.67c0,0,.07,0,.07.06-.12.87-.59,1.7-1.54,1.69s-1.35-.87-1.43-1.77C191.2,147.76,191.38,147.55,191.52,147.67Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.63,146.56c0-.06-.12.05-.13.1-.16,1.41-.58,3-1.91,3.27,0,0,0,.08,0,.08C180.17,150,180.7,147.91,180.63,146.56Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.59,144.92c-2.22-.5-3.05,4-1,4.44S181.45,145.33,179.59,144.92Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.6,145c-.4.17-.83.54-1.26.49s-.77-.61-1-1.14c0,0-.07,0-.08,0-.18.85-.07,1.8.73,2.11s1.41-.34,1.77-1.16C178.84,145.23,178.76,145,178.6,145Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,159.14c-.37.29-.76.71-1.27.7a3.56,3.56,0,0,1-1.47-.52c-.05,0-.1,0-.07.07a1.88,1.88,0,0,0,1.7,1,1.51,1.51,0,0,0,1.24-1.12C186.15,159.14,186,159.1,186,159.14Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,153.14s-.63,2-.79,3c0,.09.22.17.55.25h0a4.74,4.74,0,0,0,4.82-1c.09-.08,0-.21-.12-.16a7.08,7.08,0,0,1-4.46.52c0-.29,1.19-3.45,1-3.49a8.87,8.87,0,0,0-2.31.14c1.19-4.27,3.05-8.32,4.18-12.59a.14.14,0,0,0-.25-.11c-2.26,4.11-3.73,9-5.08,13.38C178.43,153.65,180.57,153.25,181,153.14Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,155.93a8.47,8.47,0,0,1-4.19-7.23c-16.83-6-19-18.37-19-18.37-6.17,7.79-9.58,8.35-10.5,9.53,0,0,1.12-8.15,5.62-13.16a17,17,0,0,1,20.42-3.88c5,2.38,7.87,8.32,7.87,8.32s5.42,2.44,6.23,7.73C214.92,147.73,207.09,155.93,207.09,155.93Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.89,129.57a14.53,14.53,0,0,0,1.44,7,18.51,18.51,0,0,0,4.33,5.76l1.4,1.14c.48.36,1,.66,1.51,1a24.21,24.21,0,0,0,3.18,1.69c1.1.47,2.25.83,3.37,1.25,1.17.27,2.32.57,3.48.81-1.12-.4-2.25-.76-3.37-1.15s-2.19-.89-3.24-1.41a26.17,26.17,0,0,1-5.85-3.87,19.22,19.22,0,0,1-4.31-5.47A16.61,16.61,0,0,1,183.89,129.57Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,154.11s5.44-5.72,8.11-3.68-2.12,10.8-5.72,11.55a3.5,3.5,0,0,1-4.36-2.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.87,152.91a0,0,0,0,1,0,.09c-2.54.61-4.13,2.63-5.36,4.8a1.93,1.93,0,0,1,2.94-.09s0,.14-.09.12a2.15,2.15,0,0,0-2.46.39,10.17,10.17,0,0,0-1.41,1.72c-.14.2-.51,0-.39-.21l0,0C204.54,156.62,207.56,152.72,210.87,152.91Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.3,128.36a28.4,28.4,0,0,1-8.4,3.4,29,29,0,1,1,8.4-3.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.21,100.32a8.83,8.83,0,1,1-8.72-8.93A8.82,8.82,0,0,1,667.21,100.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.34,124.72l0,3.64a28.4,28.4,0,0,1-8.4,3.4A28.84,28.84,0,0,1,642.81,128l0-3.63a15.25,15.25,0,0,1,30.49.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.54,349.47a29,29,0,0,1-30.48-.37,29,29,0,1,1,30.48.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.45,321.42a8.82,8.82,0,1,1-8.71-8.92A8.82,8.82,0,0,1,299.45,321.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.59,345.83l0,3.64a29,29,0,0,1-30.48-.37l0-3.63a15.25,15.25,0,0,1,30.49.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.43,190a18.53,18.53,0,0,1-5.5,2.23,19,19,0,1,1,5.5-2.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.44,171.63a5.78,5.78,0,1,1-5.71-5.85A5.77,5.77,0,0,1,87.44,171.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46,187.62l0,2.38a18.53,18.53,0,0,1-5.5,2.23,18.89,18.89,0,0,1-14.47-2.47l0-2.38a10,10,0,0,1,20,.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "56.86 455 136.39 454.75 215.93 454.67 375 454.5 534.07 454.66 613.61 454.75 693.14 455 613.61 455.24 534.07 455.33 375 455.5 215.93 455.33 136.39 455.24 56.86 455",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.78,359.45c-5.59,0-16.91-4.4-15-8.09s7.74,1.05,8,1.19c-.16-.27-3.94-7.65-.58-8.93s6.77,2.27,7.61,6.37c.85-4.1,4.17-7.69,7.62-6.37s-.42,8.66-.58,8.93c.24-.14,6.11-4.81,8-1.19S658.38,359.45,652.78,359.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681,389.63a69.81,69.81,0,0,1-1.43,9.17c-1.33,6-3.51,11.85-6.64,15.75a55.56,55.56,0,0,1-40.49,0c-6.68-8.34-9.06-25.49-8.11-34.31,1.72-15.93,11.24-22,19.5-24.2,0,0,0,0,0,0a35.48,35.48,0,0,1,8.84-1.13c8.1,0,25.94,2.93,28.36,25.34A50,50,0,0,1,681,389.63Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.31,354.9c.23,5.29.36,10.58.46,15.87s.12,10.59.14,15.88,0,10.59-.2,15.88a131.19,131.19,0,0,1-1.11,15.84l.2-2,.11-2c.09-1.31.09-2.64.13-4,.07-2.64.11-5.29.12-7.93,0-5.29.07-10.58,0-15.87l0-15.87C653.23,365.49,653.24,360.2,653.31,354.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.87,355A65.35,65.35,0,0,0,648,362.7c-.53,2.58-.91,5.19-1.24,7.8a148.65,148.65,0,0,0-1.09,15.77l0,4c0,1.32,0,2.63.06,3.95,0,2.64.24,5.27.36,7.91.05,1.32.19,2.63.3,3.94l.35,4,.9,7.87q-.66-3.92-1.25-7.83l-.45-3.94c-.15-1.32-.31-2.63-.39-3.95-.22-2.64-.41-5.28-.47-7.93,0-1.32-.11-2.64-.1-4v-4a139.73,139.73,0,0,1,1.26-15.83A77.48,77.48,0,0,1,649.87,355Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.29,355.67a33.28,33.28,0,0,0-4,7c-.26.62-.55,1.22-.79,1.85l-.68,1.9-.33.95c-.1.32-.19.65-.28,1l-.54,1.94a62.63,62.63,0,0,0-1.83,16l.09,4,.39,4,.2,2c.09.67.23,1.33.34,2l.68,4a18.63,18.63,0,0,0,.42,2l.48,2,1,3.92,2.39,7.74c-.93-2.53-1.82-5.09-2.73-7.64L639,406.3l-.53-2c-.17-.66-.36-1.31-.47-2l-.75-4c-.12-.67-.26-1.33-.36-2l-.22-2-.42-4.05-.12-4.07a60.74,60.74,0,0,1,2-16.1l.59-1.95c.11-.32.2-.65.31-1l.36-.95.73-1.9c.26-.63.56-1.23.85-1.85A30.66,30.66,0,0,1,645.29,355.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.91,356.58a30.11,30.11,0,0,0-5.47,6.08,35.56,35.56,0,0,0-3.9,7.17,41.79,41.79,0,0,0-3.08,15.93c-.05,1.36.06,2.72.11,4.08s.21,2.72.45,4.06l.31,2,.42,2c.13.67.27,1.34.45,2l.5,2c.35,1.32.78,2.61,1.16,3.93l1.38,3.86,1.52,3.82,1.67,3.76a80.64,80.64,0,0,1-6.26-15.23c-.35-1.33-.78-2.64-1-4l-.43-2-.33-2c-.25-1.36-.33-2.74-.49-4.11s-.18-2.75-.14-4.14A41.25,41.25,0,0,1,632,369.61a35.84,35.84,0,0,1,4.13-7.15,33.41,33.41,0,0,1,2.67-3.15A22.79,22.79,0,0,1,641.91,356.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.54,355.05a77.48,77.48,0,0,1,3.68,15.42,137.46,137.46,0,0,1,1.26,15.83v4c0,1.32-.07,2.65-.1,4-.06,2.65-.25,5.29-.46,7.92-.09,1.33-.25,2.64-.4,3.95l-.45,3.94q-.58,3.93-1.25,7.84l.9-7.88.35-3.94c.12-1.31.25-2.63.3-3.95.12-2.63.34-5.26.36-7.9,0-1.32.09-2.64.07-4l0-4a151.14,151.14,0,0,0-1.08-15.77c-.34-2.61-.72-5.22-1.25-7.81A65.68,65.68,0,0,0,656.54,355.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.13,355.71a31.4,31.4,0,0,1,4.33,6.84c.28.61.58,1.22.84,1.85l.73,1.9.37.95.3,1,.59,1.95a60.28,60.28,0,0,1,2,16.1l-.12,4.07-.42,4-.22,2c-.1.67-.24,1.33-.36,2l-.75,4a18.81,18.81,0,0,1-.47,2l-.53,2-1.06,3.92c-.91,2.55-1.8,5.1-2.73,7.64l2.39-7.74,1-3.93.48-2a18.63,18.63,0,0,0,.42-2l.68-4c.12-.67.25-1.33.34-2l.2-2,.39-4,.09-4a62.13,62.13,0,0,0-1.83-16l-.54-1.94c-.09-.33-.17-.65-.27-1l-.34-.95-.68-1.9c-.24-.63-.53-1.24-.79-1.86A32.49,32.49,0,0,0,661.13,355.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.5,356.62a22.79,22.79,0,0,1,3.08,2.73,31.05,31.05,0,0,1,2.67,3.15,35.84,35.84,0,0,1,4.13,7.15,41.22,41.22,0,0,1,3.28,16.14c0,1.38-.08,2.76-.13,4.14s-.25,2.75-.5,4.11l-.33,2-.43,2c-.25,1.36-.68,2.67-1,4A81.19,81.19,0,0,1,669,417.33l1.67-3.76,1.52-3.82,1.38-3.87c.38-1.31.82-2.61,1.16-3.93l.5-2c.18-.65.32-1.32.46-2l.41-2,.31-2c.24-1.34.3-2.71.45-4.06s.16-2.72.11-4.08a41.79,41.79,0,0,0-3.08-15.93,35.56,35.56,0,0,0-3.9-7.17A29.84,29.84,0,0,0,664.5,356.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.42,373.82a34.25,34.25,0,0,1,2.34,3.53h-.43c.4-.71.82-1.42,1.26-2.11.22-.35.44-.69.67-1s.46-.67.72-1c-.15.39-.33.75-.5,1.13s-.35.74-.54,1.1c-.38.73-.77,1.45-1.18,2.15l-.21.37-.21-.37A36.06,36.06,0,0,1,651.42,373.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.37,372a15.14,15.14,0,0,1,.18,5.48,15.14,15.14,0,0,1-.18-5.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.76,355.07a35.15,35.15,0,0,1,0,4.23l-.35-.23c.72-.38,1.45-.74,2.19-1.09l1.13-.49c.38-.15.76-.32,1.15-.45-.34.24-.69.45-1,.68l-1.06.63c-.71.4-1.43.79-2.16,1.16l-.38.19,0-.42A37.36,37.36,0,0,1,669.76,355.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.38,354.59a12.91,12.91,0,0,1-1.2,2.48,13.47,13.47,0,0,1-1.63,2.22,13.84,13.84,0,0,1,1.2-2.48A13.47,13.47,0,0,1,672.38,354.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.37,367.73a36.17,36.17,0,0,1,1.91,3.78l-.42-.05c.48-.66,1-1.31,1.48-1.95.26-.32.52-.63.79-.94s.54-.62.83-.91c-.19.36-.41.71-.62,1.06s-.44.69-.67,1c-.46.68-.93,1.35-1.42,2l-.25.35-.17-.4A33.58,33.58,0,0,1,665.37,367.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.51,366.14a13.31,13.31,0,0,1,0,2.75,13.48,13.48,0,0,1-.47,2.72,13.42,13.42,0,0,1,0-2.76A14,14,0,0,1,667.51,366.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.41,409.55a34.25,34.25,0,0,1,2.34,3.53h-.43c.4-.71.82-1.42,1.26-2.11.21-.34.44-.69.67-1s.46-.67.72-1c-.15.39-.33.76-.5,1.13s-.36.74-.54,1.1c-.38.73-.77,1.45-1.18,2.15l-.22.37-.21-.36A37.16,37.16,0,0,1,657.41,409.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.36,407.72a15.14,15.14,0,0,1,.18,5.48,15.14,15.14,0,0,1-.18-5.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.79,361.31a36.88,36.88,0,0,1,1.22,4.05l-.41-.12c.59-.56,1.19-1.12,1.81-1.65l.94-.79c.32-.25.64-.52,1-.75-.26.32-.54.62-.8.93l-.84.9c-.57.59-1.15,1.16-1.75,1.72l-.32.29-.09-.41A36.76,36.76,0,0,1,638.79,361.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.18,360.12a13.59,13.59,0,0,1-.46,2.71,13.41,13.41,0,0,1-1,2.59,12.92,12.92,0,0,1,.47-2.71A13.38,13.38,0,0,1,641.18,360.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.28,376.55a36.84,36.84,0,0,1-.44,4.21l-.33-.26c.76-.3,1.53-.58,2.31-.83l1.17-.37c.4-.11.79-.22,1.19-.31-.36.2-.73.37-1.1.55s-.74.34-1.12.5c-.75.33-1.51.63-2.28.91l-.4.15.07-.42A35.12,35.12,0,0,1,682.28,376.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685,376.38a15.19,15.19,0,0,1-3.36,4.34,14.28,14.28,0,0,1,1.48-2.32A13.29,13.29,0,0,1,685,376.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.36,392.12a34.36,34.36,0,0,1,2.38,3.51h-.43c.4-.71.81-1.42,1.23-2.12l.66-1c.24-.34.46-.69.71-1-.15.38-.32.75-.48,1.13s-.35.74-.53,1.11c-.37.73-.75,1.45-1.16,2.16l-.21.38-.21-.37A36.19,36.19,0,0,1,643.36,392.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.29,390.27a14.22,14.22,0,0,1,.37,2.73,13.38,13.38,0,0,1-.13,2.75,15.16,15.16,0,0,1-.24-5.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.74,401.48a36.61,36.61,0,0,1,3.52,2.36l-.4.17c.1-.81.21-1.62.35-2.43.07-.4.14-.81.22-1.21s.17-.8.28-1.2c0,.41,0,.82,0,1.23s-.05.82-.08,1.23c-.07.82-.15,1.63-.26,2.44l-.06.42-.33-.26A34.9,34.9,0,0,1,628.74,401.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.83,399a13.63,13.63,0,0,1,1.37,2.4,13.33,13.33,0,0,1,.91,2.6,13.63,13.63,0,0,1-1.37-2.4A13.33,13.33,0,0,1,629.83,399Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.11,364.33A35.34,35.34,0,0,1,629,366l-.35.24c-.06-.82-.1-1.63-.12-2.45,0-.41,0-.82,0-1.23s0-.82.05-1.23c.09.4.14.81.21,1.21s.11.82.15,1.22c.09.82.16,1.63.21,2.45l0,.42-.38-.19A37.33,37.33,0,0,1,625.11,364.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.73,361.73a15.07,15.07,0,0,1,3.17,4.47,15.07,15.07,0,0,1-3.17-4.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,391.18a35.3,35.3,0,0,1,2,3.74l-.43,0c.47-.68.95-1.33,1.45-2,.25-.33.5-.65.76-1s.53-.63.81-.93c-.18.37-.4.72-.6,1.07s-.42.7-.64,1.05c-.44.69-.9,1.37-1.38,2l-.25.35-.17-.39A35.41,35.41,0,0,1,675,391.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.13,389.54a13.44,13.44,0,0,1,.08,2.76,12.71,12.71,0,0,1-.42,2.72,13.44,13.44,0,0,1-.08-2.76A14.11,14.11,0,0,1,677.13,389.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "628.93 414.94 677.02 414.94 672.17 455.15 633.77 455.15 628.93 414.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "628.93 414.94 630.02 424.01 676.19 421.79 677.02 414.94 628.93 414.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.91,
    y: 409.86,
    width: 54.13,
    height: 7.19,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.88,
    y: 133.48,
    width: 150.53,
    height: 150.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.4,285H521.88V132.48H674.4Zm-150.52-2H672.4V134.48H523.88Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 673.4,
    cy: 133.48,
    r: 18.64,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.24 144.29 663.09 136.04 665.83 133.34 670.59 138.16 680.47 122.67 683.71 124.73 671.24 144.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.84,236.52a12.55,12.55,0,0,1-.24,1.25c-.38,1.55-1,3.89-1.82,6.81,0,.11-.07.23-.1.36l-.18.61s0,0,0,0c-2.27,7.9-5.92,19.5-10.5,30.89-.18.44-.35.88-.53,1.31-.85,2.1-1.74,4.19-2.65,6.24h-60v-4.35c9.91-.13,19.67-.7,22.14-1,1.06-.16,3.18-2.31,6-5.69,1.58-1.93,3.38-4.25,5.32-6.83,1.55-2.05,3.19-4.26,4.88-6.55.27-.38.54-.75.83-1.13,6.82-9.29,14.47-19.79,20.66-26.9,2.85-3.27,5.35-5.1,7.48-5.9l.24-.08.59-.18a.35.35,0,0,1,.14,0,7.33,7.33,0,0,1,1-.17h0c3.76-.31,6.06,3,6.69,7h0A14.68,14.68,0,0,1,598.84,236.52Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.78,236a36.3,36.3,0,0,1-1.42,7.72c-.21.74-.49,1.66-.83,2.77l-.1.34c-.06.18-.12.35-.18.54-2,6.47-5.93,17.84-10.74,29.42-.17.44-.35.87-.54,1.3-.83,2-1.68,4-2.56,5.91H522.87v-5.9c9.24,0,21.61-.08,22.76-.9a60.08,60.08,0,0,0,4.41-5.06l.59-.73c1.42-1.73,3.06-3.76,4.85-6s3.59-4.49,5.52-6.93c7.57-9.57,16.11-20.49,21-26.84,2.84-3.69,5.87-5.91,8.61-6.73a1.87,1.87,0,0,1,.32-.08h0c.19-.05.38-.1.56-.13l.46-.07a2.7,2.7,0,0,1,.41-.05l.54,0a2.82,2.82,0,0,1,.41,0h0c3.1.16,5.47,2.5,6.21,6.88A20,20,0,0,1,599.78,236Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.92,280.89c0,.27,0,.54,0,.81v-.87A.06.06,0,0,1,522.92,280.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.78,236a36.3,36.3,0,0,1-1.42,7.72c-.21.74-.49,1.66-.83,2.77l-.1.34c-.06.18-.12.35-.18.54-2,6.47-5.93,17.84-10.74,29.42-.17.44-.35.87-.54,1.3-.83,2-1.68,4-2.56,5.91H542.69l8.74-10.72,5.47-6.7,5.14-6.3.89-1.09,10.94-13.42L589,227.25l0,0,1.38-1.7.57-.69,0,0h0c.19-.05.38-.1.56-.13l.46-.07a2.7,2.7,0,0,1,.41-.05l.54,0a2.82,2.82,0,0,1,.41,0h0c3.1.16,5.47,2.5,6.21,6.88A20,20,0,0,1,599.78,236Z",
    style: {
      fill: "#050400",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.28,284H558.47a31.25,31.25,0,0,1-.34-5.35,23,23,0,0,1,2-9.21.33.33,0,0,1,.07-.13c.69-1.5,2-4.11,3.82-7.33.23-.39.45-.82.68-1.24,2.48-4.4,5.66-9.74,9.12-15,4.92-7.46,10.4-14.68,15.1-18.52l0,0c.34-.29.67-.53,1-.78s.62-.43.94-.62a1.06,1.06,0,0,1,.26-.17c.3-.18.59-.35.89-.51h0a10,10,0,0,1,1.24-.58h0a19.89,19.89,0,0,1,14.15-.15,17.79,17.79,0,0,1,1.77.65c.72.29,1.43.62,2.12,1h0a27.42,27.42,0,0,1,2.64,1.57h0a23.78,23.78,0,0,1,3.42,2.76,16.78,16.78,0,0,1,1.68,1.91,101.57,101.57,0,0,1,13.68,25.83c.17.43.33.88.48,1.32.85,2.34,1.66,4.8,2.46,7.4s1.61,5.5,2.39,8.49Q639.26,279.45,640.28,284Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.25,284H625.19c-.28-.7-.59-1.46-.9-2.26-.94-2.35-2-5.07-3.19-8.05-.91-2.34-1.86-4.82-2.81-7.39-.17-.42-.32-.85-.47-1.29-2.34-6.31-4.66-13.08-6.4-19.36-1.62-5.81-2.24-9.92-2.15-12.68,0-.16,0-.33,0-.49h0a4.07,4.07,0,0,1,.06-.61h0c.29-2.66,1.42-3.72,3-3.72,1.43,0,3.25.89,5.14,2.24a36,36,0,0,1,4.43,3.85c5,5.1,11.81,12.12,18.69,19.81l1,1.05c1.69,1.92,3.41,3.87,5.1,5.85,1.9,2.22,3.8,4.48,5.61,6.74,2.54,3.12,5,6.25,7.15,9.29a2.61,2.61,0,0,1,.19.27C661.31,279.54,662.86,281.81,664.25,284Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.14,284H624.26c-.24-.61-.5-1.25-.76-1.92-.17-.41-.34-.84-.51-1.27-.45-1.13-.93-2.31-1.42-3.56l-.84-2.12-.26-.65c0-.14-.1-.28-.16-.44-.92-2.36-1.9-4.85-2.88-7.38-.16-.43-.33-.85-.49-1.28-1.24-3.28-2.47-6.59-3.59-9.75h0a118.14,118.14,0,0,1-4.74-15.72,46.85,46.85,0,0,1-.68-5l0-.47c0-.22,0-.44,0-.65-.16-4.75,1.09-7.3,4.3-6.76a8.57,8.57,0,0,1,1.9.58h0a30,30,0,0,1,6.48,4.2c4.21,3.38,12.25,11.82,20.74,21.84.3.37.61.72.91,1.08,1.63,1.93,3.26,3.93,4.9,5.94,1.83,2.27,3.64,4.57,5.41,6.87,2.42,3.17,4.76,6.33,6.91,9.42a2.61,2.61,0,0,1,.19.27C661.25,279.54,662.76,281.81,664.14,284Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.84,284h-1.08c-1.54-3.66-3-7.38-4.4-11.09-.71-1.85-1.38-3.72-2.07-5.58-.5-.83-1-1.66-1.44-2.53a49.31,49.31,0,0,1-2.07-4.56.06.06,0,0,1,.11-.06c.79,1.48,1.59,2.95,2.37,4.42a.6.6,0,0,1,.08.16l-.21-.55c-.5-1.41-1-2.8-1.45-4.22-.22-.69-.45-1.38-.66-2.07a12.45,12.45,0,0,0-.46-1.34c-.25-.55-.06-.33-.21-.95h0a.65.65,0,0,0,0-.13c0-.08.11-.12.14-.05.53,1.2.16.09.58,1.34.1.34.28.68.41,1,.27.68.53,1.36.8,2,.58,1.46,1.14,2.93,1.7,4.41l.39,1c.16.44.32.87.49,1.29.79,2.07,1.61,4.13,2.42,6.19.15.4.32.78.47,1.18,1.07,2.68,2.17,5.33,3.26,8C624.26,282.57,624.56,283.29,624.84,284Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.13,226.84c-.48,1.63-9,11.89-16.49,11.1-2.45-.26-1.62-13.69-1.62-13.69l-.17-1-2.31-14.07,16.91-9.54,2.44-1.25s.38,3.89.8,8.74c0,.23,0,.45.06.69a7.29,7.29,0,0,1,.08.79c.08.72.15,1.46.2,2.2.05.56.09,1.11.12,1.7s.07,1.17.11,1.76A93,93,0,0,1,609.13,226.84Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.69,207.13a28.61,28.61,0,0,1-17.84,16.12l-2.31-14.07,16.91-9.54,2.44-1.25S608.27,202.28,608.69,207.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.27,182.92c-6.58,24.14,7.14,30.81,12.35,32.22,4.72,1.29,21,5.06,30-18.28s-.1-34-10.76-37.53S578.86,158.77,572.27,182.92Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.73,179.42a16.66,16.66,0,0,0,1.73.05,2.77,2.77,0,0,0,1.77-.29.89.89,0,0,0,.25-1.06,2.23,2.23,0,0,0-2-1,3.28,3.28,0,0,0-2.25.64A1,1,0,0,0,579.73,179.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.43,184.25a17.17,17.17,0,0,1-1.57-.72,2.78,2.78,0,0,1-1.47-1,.9.9,0,0,1,.24-1.06,2.21,2.21,0,0,1,2.24,0A3.23,3.23,0,0,1,597.6,183,1,1,0,0,1,596.43,184.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.34,189c0-.06.11.11.09.18-.46,1.64-.71,3.59.65,4.51,0,0,0,.11,0,.09C590.28,193.09,590.64,190.5,591.34,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.24,187.66c2.71.45,1.6,5.84-.91,5.42S591,187.27,593.24,187.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.24,188.16c.41.4.76,1,1.31,1.21s1.26-.26,1.8-.72c.06,0,.09,0,.08.08-.2,1-.81,2-1.95,1.94s-1.58-1.13-1.62-2.22C593.85,188.25,594.08,188,594.24,188.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.48,186.26c0-.07-.15.05-.16.11-.31,1.68-.94,3.55-2.57,3.78,0,0-.06.09,0,.09C580.64,190.38,581.46,187.89,581.48,186.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.37,184.19c-2.64-.78-4,4.55-1.57,5.27S582.58,184.85,580.37,184.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.17,184.26c-.5.17-1,.58-1.56.48s-.87-.8-1.1-1.44c0-.07-.08,0-.1,0-.29,1-.23,2.16.7,2.61s1.73-.3,2.23-1.25C579.44,184.51,579.37,184.19,579.17,184.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.16,202.17c-.47.33-1,.81-1.58.76a4.48,4.48,0,0,1-1.74-.71.06.06,0,0,0-.09.07,2.3,2.3,0,0,0,2,1.26,1.82,1.82,0,0,0,1.57-1.28C587.35,202.18,587.22,202.12,587.16,202.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.51,194.63s-.89,2.41-1.14,3.58c0,.11.25.23.64.34,0,0,0,0,0,0a5.67,5.67,0,0,0,5.86-.9.12.12,0,0,0-.13-.2,8.59,8.59,0,0,1-5.41.35c0-.35,1.65-4.08,1.47-4.14a10.89,10.89,0,0,0-2.79,0c1.7-5.07,4.2-9.83,5.82-14.91,0-.19-.2-.3-.29-.15-3,4.81-5.06,10.61-7,15.8C578.39,195.08,581,194.73,581.51,194.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.56,199.11c-4.06-.75-2.76-9.33-2.76-9.33s-8.09-2.12-7.68-14.45a18.52,18.52,0,0,0,1,10.56s-13.85-5.28-16.69-18.8c0,0,.79,6.71,2.46,9.46,0,0-5.54-3.25-7.17-8.87,0,0-4.32,6.22-6.74,7.61,0,0,7.19-24.78,29.59-16,0,0,14.21,4.8,16.38,17.62S612.56,199.11,612.56,199.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.56,197s6.77-6.71,9.91-4.16-2.92,12.95-7.29,13.73a4.24,4.24,0,0,1-5.18-3.25Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.66,195.77c.07,0,.06.1,0,.11-3.08.64-5.08,3-6.64,5.6,1.05-.91,2.32-1.28,3.56,0a.09.09,0,0,1-.11.14,2.61,2.61,0,0,0-3,.39,12.22,12.22,0,0,0-1.76,2c-.18.23-.62,0-.47-.27l0-.06C609.89,200,613.66,195.42,617.66,195.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645,164.7a4.18,4.18,0,0,0-.17-5.85,3.71,3.71,0,0,0-1.46-5.37,5.46,5.46,0,0,0-1.68-4.86,2.36,2.36,0,0,1-.61-.86,4.16,4.16,0,0,0-.68-3.48,3.1,3.1,0,0,0-3.51-1,6.06,6.06,0,0,0-2-2.2,4.16,4.16,0,0,0-4.16-.43,5.94,5.94,0,0,0-8.82-1.13,4.3,4.3,0,0,0-4.31-2c-2,.24-3.66,1.67-5,3.15a3,3,0,0,0-3.84-.62,3.31,3.31,0,0,0-1.5,2.8,4.6,4.6,0,0,0-3,1.85,2.75,2.75,0,0,0,0,3,4.13,4.13,0,0,0-2.23,6.07c.1.14.19.27.3.4a1.92,1.92,0,0,0,.19.23,5.49,5.49,0,0,0-1.25.33h0a4.91,4.91,0,0,0-2.89,2.86h0a4,4,0,0,0-.16.57,4.28,4.28,0,0,0-.11.8,2.09,2.09,0,0,0,0,.25,4.58,4.58,0,0,0,.15,1.17,5.13,5.13,0,0,0,1.5,2.58,4.39,4.39,0,0,0-2.22,4.24,6.47,6.47,0,0,0,3.31,4.75,4.39,4.39,0,0,0,.2,4.85,3.94,3.94,0,0,0,.82.86,2,2,0,0,0,.33.26,6.39,6.39,0,0,0,2.81,1,4.88,4.88,0,0,1-2.71-.09,2.62,2.62,0,0,1-.48-.22,4,4,0,0,1-1.22-1,4.6,4.6,0,0,1,.19-5.69s0,0,0,0a4.52,4.52,0,0,0-.46,6,4.08,4.08,0,0,0,1.51,1.2l.53.22a5.31,5.31,0,0,0,3.57-.21,5.11,5.11,0,0,0,6.87,5.91,3.25,3.25,0,0,0,.43-.18,6,6,0,0,0,4.22,3.05,5.46,5.46,0,0,0,1.51,0l.38-.06a3.78,3.78,0,0,0,.7-.18h0a4.63,4.63,0,0,0,2.59-2.38l.22-.51h0a3.85,3.85,0,0,0,3-.05,3.92,3.92,0,0,0,.5-.33l.32-.2a2.49,2.49,0,0,1,1.45-.21,10.23,10.23,0,0,0,1.66,0c1.7-.17,3.52-.94,4.08-2.66a5.52,5.52,0,0,0,6.48-2.37,5.38,5.38,0,0,0,.41-.92c.14-.44.15-1,.49-1.37a4.32,4.32,0,0,1,1.32-.71,5.8,5.8,0,0,0,1-.63,2.14,2.14,0,0,0,.62-2.76,3.52,3.52,0,0,0,2.31-3.1A6.06,6.06,0,0,0,645,164.7ZM609,140.33c1.32-.85,2.52-.35,3.57.51l-.07.09a3.17,3.17,0,0,0-3.64.28,3.38,3.38,0,0,0-1.09,1.58h0A2.73,2.73,0,0,1,609,140.33ZM622.49,185a5,5,0,0,1-2.34,2.27,4.23,4.23,0,0,1-.88.27,1.74,1.74,0,0,1-.39,0,4.18,4.18,0,0,1-1.4-.1,6.6,6.6,0,0,1-2.77-1.34,5.69,5.69,0,0,0,2.85,1,6.44,6.44,0,0,0,1.24-.06,1.51,1.51,0,0,0,.37-.07,4.8,4.8,0,0,0,1.19-.41,5.44,5.44,0,0,0,2.09-1.69.91.91,0,0,0,.13-.16s0,0,0,0Zm18.4-38a4.83,4.83,0,0,0-.34-1.08,4.35,4.35,0,0,0-1.71-1.82,4.63,4.63,0,0,0-1.13-.46c-.22,0-.67-.09-.67-.09l-.06-.16a3.29,3.29,0,0,1,3.45,1.61,4,4,0,0,1,.49,2.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,205.81c-.26,1.14,3.84-2.08,4.11-2.63s2.88-1.8,3.69-2.82a29.25,29.25,0,0,0,2.84-4.89c.24-.78,2.08-2.49,2.34-3.9s2.07-14-4.75-24-14.18-11.94-14.18-11.94A53,53,0,0,0,595.81,153c-6.22-.73-17.76,12-17.84,12.3a5.27,5.27,0,0,1-.3,2.18c-.46.81-1.56,1.53-1.24,2.44s-1.31,2.82-1.46,3.71,0,1.16-.23,1.74,5.54-14.48,25.35-16.36C600.09,159,618.7,181.38,613,205.81Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.8,175.18a.58.58,0,0,1-.06.17S574.73,175.34,574.8,175.18Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.8,175.18a.58.58,0,0,1-.06.17S574.74,175.34,574.8,175.18Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.54,159.4a1.52,1.52,0,0,0-.8-.91,1.51,1.51,0,0,0-.64-.18c-.6.49-1.16,1-1.71,1.47v0a1.64,1.64,0,0,0,.65,1.45l.18.1.06,0,.15.06h0a1.59,1.59,0,0,0,.86.09h0a1.67,1.67,0,0,0,1-.64.68.68,0,0,0,.14-.23,1.55,1.55,0,0,0,.17-.93A1.21,1.21,0,0,0,586.54,159.4Zm7.39-.66a1.62,1.62,0,0,0-1.88.31,1.43,1.43,0,0,0-.31.41,1.67,1.67,0,0,0-.07,1.31,1.6,1.6,0,0,1,.26-.08l0,0c.44-.15.87-.28,1.33-.41s1-.27,1.49-.39A1.62,1.62,0,0,0,593.93,158.74Zm-12,6.46a1,1,0,0,0-.22-.14l-.13-.05a.77.77,0,0,0-.27-.08,1.37,1.37,0,0,0-.75,0h0a1.63,1.63,0,0,0-1,.83,1.9,1.9,0,0,0-.17.76,1.47,1.47,0,0,0,0,.36h0a1.57,1.57,0,0,0,.09.23.31.31,0,0,0,.07.14,1.47,1.47,0,0,0,.52.59,31,31,0,0,1,2.35-2.09A1.43,1.43,0,0,0,582,165.2Zm36.19-1.64-.53-.58c-.16-.18-.32-.34-.48-.51s-.24-.25-.37-.38-.52-.52-.76-.75h0a1.8,1.8,0,0,0-.29.26,1.41,1.41,0,0,0-.23.35,1.62,1.62,0,0,0,.71,2.18,1.72,1.72,0,0,0,.76.17,1,1,0,0,0,.35-.05,1.49,1.49,0,0,0,.3-.09l.16-.08a1.69,1.69,0,0,0,.41-.35l.07-.08A.7.7,0,0,0,618.16,163.56Zm-3.51,11.34a1.63,1.63,0,1,0,.65,2.3s0,0,0-.07,0,0,0,0A1.64,1.64,0,0,0,614.65,174.9Zm-16.21-21.53c-.51-.09-1.05-.18-1.59-.25h0a1.62,1.62,0,0,0,.13,1.67,1.58,1.58,0,0,0,.59.52,1.33,1.33,0,0,0,.55.15h.17a1.57,1.57,0,0,0,1.19-.52,1.26,1.26,0,0,0,.27-.37,1.2,1.2,0,0,0,.13-.36.31.31,0,0,0,0-.1,0,0,0,0,0,0,0,.06.06,0,0,0,0-.06,1.27,1.27,0,0,0,0-.39Zm8.53,4.3a.09.09,0,0,0-.07,0,1.5,1.5,0,0,0-1.24,0,1.54,1.54,0,0,0-.87.78,1.63,1.63,0,0,0-.17.91,1.83,1.83,0,0,0,.07.32,1.57,1.57,0,0,0,.32.56,1.67,1.67,0,0,0,.5.4,1.63,1.63,0,0,0,1,.15,1.38,1.38,0,0,0,.43-.15h0a1.53,1.53,0,0,0,.27-.17,1.51,1.51,0,0,0,.46-.56A1.61,1.61,0,0,0,607,157.67Zm3.95,9.64a1.59,1.59,0,0,0-.44-.8h0a1,1,0,0,0-.19-.16.62.62,0,0,0-.21-.13,1.14,1.14,0,0,0-.35-.13l-.21,0a.32.32,0,0,0-.13,0h-.13a1.64,1.64,0,0,0-1.36.9,1.55,1.55,0,0,0-.17.68,1.62,1.62,0,0,0,3.07.79A1.57,1.57,0,0,0,610.92,167.31Zm10.78,3a1.63,1.63,0,0,0-2.19.72,1.47,1.47,0,0,0-.16.84v0a1.6,1.6,0,0,0,.44,1h0a1.12,1.12,0,0,0,.42.32,1.63,1.63,0,1,0,1.47-2.9Zm-2.2,12.17a1.62,1.62,0,0,0-1.27-.08,2,2,0,0,0-.51.29,1.48,1.48,0,0,0-.24.26.87.87,0,0,0-.15.25,1.63,1.63,0,0,0,.56,2.1l.15.09a1.28,1.28,0,0,0,.33.11,1.26,1.26,0,0,0,.38.06,1.66,1.66,0,0,0,1.48-.9A1.62,1.62,0,0,0,619.5,182.44Zm-4.68,17.75a1.45,1.45,0,0,0-.89-.16.22.22,0,0,1,0,.08c0,.19,0,.39,0,.57,0,0,0,.06,0,.08v0s0,.08,0,.14V201a2.39,2.39,0,0,1-.05.36s0,0,0,0a3.18,3.18,0,0,1-.06.43c0,.13,0,.24,0,.37s-.07.52-.13.79a.88.88,0,0,1,0,.16v0a1.62,1.62,0,0,0,1.28-3Zm-1.39-13.55-.35-.14c0,.17.07.34.09.51q.26,1.2.42,2.43a1.6,1.6,0,0,0-.16-2.8Zm12.64-5.81L626,180c-.06-.39-.13-.79-.2-1.19a1.62,1.62,0,0,0-.84,3.06,1.48,1.48,0,0,0,1.28.07h0C626.17,181.59,626.12,181.22,626.07,180.83ZM619.79,192a1.65,1.65,0,0,0-.72-.17h0a1.31,1.31,0,0,0-.39,0,1.53,1.53,0,0,0-.7.39h0a1,1,0,0,0-.19.21,1.94,1.94,0,0,0-.15.24s0,0,0,0a1.63,1.63,0,0,0,.72,2.16l.08,0a.79.79,0,0,0,.32.1,1.6,1.6,0,0,0,1.57-.52,1.9,1.9,0,0,0,.22-.33A1.62,1.62,0,0,0,619.79,192Zm1.9,5.83a1.65,1.65,0,0,0-.06,1.32c0-.07.09-.15.15-.23.14-.24.3-.48.45-.73.24-.42.49-.85.7-1.24A1.67,1.67,0,0,0,621.69,197.84Zm2.84-9.22a1.62,1.62,0,0,0,.72,2.18,1.48,1.48,0,0,0,.84.17,1.92,1.92,0,0,1,0-.32c0-.18,0-.38.07-.6V190a.17.17,0,0,1,0-.07c0-.17,0-.37,0-.6a4.66,4.66,0,0,0,0-.56c0-.15,0-.31,0-.49s0-.34,0-.51A1.63,1.63,0,0,0,624.53,188.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.13,203.18a16.94,16.94,0,0,0,.71-3.38c.17-1.14.3-2.28.42-3.43.24-2.29.46-4.58.58-6.88,0-.57.07-1.15.06-1.71a7,7,0,0,0-.33-1.65c-.32-1.1-.72-2.18-1.1-3.26s-.8-2.17-1.22-3.24L615,176.4q1.49,3.14,2.76,6.36c.43,1.07.82,2.16,1.16,3.27a7.58,7.58,0,0,1,.37,1.74c0,.59,0,1.16,0,1.74q-.22,3.47-.67,6.9c-.16,1.14-.33,2.29-.54,3.42-.1.57-.22,1.14-.36,1.7A8.17,8.17,0,0,1,617.13,203.18Z",
    style: {
      fill: "#050400",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.44,179.64a31.37,31.37,0,0,1,3.14,7.64,20.21,20.21,0,0,1,.62,4.1,11.53,11.53,0,0,1-.54,4.09c.05-.34.11-.68.17-1a3,3,0,0,0,.06-.51l0-.51c0-.17,0-.34,0-.51v-.51c0-.34,0-.68-.05-1l-.11-1-.16-1c0-.33-.13-.66-.2-1s-.14-.66-.24-1a38.57,38.57,0,0,0-1.21-3.92c-.22-.64-.47-1.28-.73-1.92S620.72,180.27,620.44,179.64Z",
    style: {
      fill: "#050400",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,166.79a21.4,21.4,0,0,1,2.75-2.8c1-.88,2-1.71,3-2.53a39.11,39.11,0,0,1,3.16-2.34,13.2,13.2,0,0,1,3.63-1.5,16.61,16.61,0,0,0-1.78.79,13.39,13.39,0,0,0-1.68,1c-.53.36-1,.76-1.55,1.17L584,161.78,581,164.22c-.51.41-1,.83-1.51,1.25A15,15,0,0,0,578,166.79Z",
    style: {
      fill: "#050400",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.43,170.5a21.92,21.92,0,0,1,1.73-2.24,25.27,25.27,0,0,1,2-2,12,12,0,0,1,1.09-.92c.39-.26.78-.54,1.17-.79l1.19-.78c.4-.25.79-.5,1.2-.74-.35.31-.73.6-1.09.9l-1.11.87c-.37.29-.75.56-1.13.85a12.51,12.51,0,0,0-1.05.9c-.69.64-1.34,1.31-2,2-.34.33-.66.67-1,1S576.75,170.16,576.43,170.5Z",
    style: {
      fill: "#050400",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.81,165.58c-3.4.76-11.17,2.41-12.8,2a13,13,0,0,1-1.59-.64,62,62,0,0,0-5.33-7.93,36.17,36.17,0,0,0-6.81,1.27,34,34,0,0,1-4.23-4.89c2.43-1.57,4.84-2.61,6.76-2.39a53,53,0,0,1,11.26,2.64S613.44,157.31,619.81,165.58Z",
    style: {
      fill: "#050400",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.83,155.74s-4.85-9.3-13.82-11c0,0-.28,9,2.68,12.18,1.48,1.58,8.52,2.7,9.43,1.59A16,16,0,0,0,601.83,155.74Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.19,148.05c-.2-.15-.4-.3-.61-.44l-.63-.43-.45-.28-.54-.31a1.61,1.61,0,0,0,2.5,1.67A1.78,1.78,0,0,0,595.19,148.05Zm-5.67,3.09a1.61,1.61,0,0,0-1.09-.14c.06.41.14.83.22,1.24,0,.14.07.28.1.42s.13.49.2.74c0,0,0,.06,0,.09l.21.67a1.63,1.63,0,0,0,.34-3Zm10,1.64a1.8,1.8,0,0,0-.49-.38,1.61,1.61,0,0,0-2.17.72h0a1.62,1.62,0,0,0,.13,1.67,1.58,1.58,0,0,0,.59.52,1.33,1.33,0,0,0,.55.15h.17a1.57,1.57,0,0,0,1.19-.52,1.26,1.26,0,0,0,.27-.37,1.2,1.2,0,0,0,.13-.36.31.31,0,0,0,0-.1v0h0a.06.06,0,0,0,0-.06,1.7,1.7,0,0,0,0-.39A1.75,1.75,0,0,0,599.51,152.78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.83,155.74a17.25,17.25,0,0,1-1.7,2.78.38.38,0,0,1-.15.12.75.75,0,0,1-.22.12l-.18.06a10.09,10.09,0,0,1-3.93-.08,21.08,21.08,0,0,1,1.25-3.82,5.89,5.89,0,0,1,2.88-2.27A21.73,21.73,0,0,1,601.83,155.74Z",
    style: {
      fill: "#050400",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,157.13s12.74-1,18.6,2.12c0,0-3.77,6.33-10.19,7.5-2.88.52-10.78-5.2-10.23-6.65A12.57,12.57,0,0,1,604,157.13Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.67,161.23a1.67,1.67,0,0,0-1.65.11h0a1.8,1.8,0,0,0-.29.26,1.41,1.41,0,0,0-.23.35,1.62,1.62,0,0,0,.71,2.18,1.72,1.72,0,0,0,.76.17,1,1,0,0,0,.35-.05,1.49,1.49,0,0,0,.3-.09l.16-.08a1.69,1.69,0,0,0,.41-.35l.06-.08h0c0-.07.09-.16.14-.24A1.65,1.65,0,0,0,617.67,161.23ZM607,157.67a.09.09,0,0,0-.07,0,1.5,1.5,0,0,0-1.24,0,1.54,1.54,0,0,0-.87.78,1.63,1.63,0,0,0-.17.91,1.83,1.83,0,0,0,.07.32,1.57,1.57,0,0,0,.32.56,1.67,1.67,0,0,0,.5.4,1.63,1.63,0,0,0,1,.15,1.38,1.38,0,0,0,.43-.15h0a1.53,1.53,0,0,0,.27-.17,1.51,1.51,0,0,0,.46-.56A1.61,1.61,0,0,0,607,157.67Zm3.31,8.68a.62.62,0,0,0-.21-.13,1.14,1.14,0,0,0-.35-.13l-.21,0a.32.32,0,0,0-.13,0h-.09c.21.1.42.18.62.26l.56.2A1,1,0,0,0,610.28,166.35Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.85,157a7.46,7.46,0,0,1-.53,4.16,6.3,6.3,0,0,1-1.8,1.94c-1.55-1.23-2.59-2.42-2.39-3a13,13,0,0,1,1.83-3S605.09,157,606.85,157Z",
    style: {
      fill: "#050400",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.07,160.07a4.15,4.15,0,1,1-1.37-5.7A4.15,4.15,0,0,1,605.07,160.07Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.87,224.58l3.68,11.31L609.13,223l3.54,4.72s-14.85,21.07-14.86,20.07L594,238l-7,6.11,1.69-16.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.36,236c.37-2.71.66-5.44,1.16-8.13,0-.09.17-.12.18,0,.36,2.66-1.11,13-1.27,15.5l0,0c.29-.26,6.45-5.35,6.5-5.26.87,1.57,3.7,8.67,3.88,9.31,2.35-3.35,11.31-15.49,14-18.62a.1.1,0,0,1,.16.11c-2.12,3.56-14,19.92-14.16,19.86a108.31,108.31,0,0,1-4-10.31c-1.06,1.13-7.32,6.92-7.31,6.52A86.3,86.3,0,0,1,587.36,236Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 58.11,
    width: 150.53,
    height: 150.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.12,209.64H289.6V57.12H442.12Zm-150.52-2H440.12V59.12H291.6Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.12,
    cy: 58.11,
    r: 18.64,
    transform: "translate(312.7 484.11) rotate(-80.73)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.96 68.92 430.82 60.68 433.55 57.98 438.31 62.8 448.19 47.3 451.43 49.37 438.96 68.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.93,208.64H316.57c6-21.88,16.08-48.36,32.25-68.32.82-1,1.65-2,2.51-3l.05,0a11.2,11.2,0,0,1,2.59-2.14,13.61,13.61,0,0,1,2.59-1.29,15.74,15.74,0,0,1,1.55-.54,29,29,0,0,1,7.92-1.12c5.71-.06,10.9,1.27,12,2.83.14.2.28.4.4.61.33.45.63.93.92,1.42a2.59,2.59,0,0,1,.19.31c.14.22.28.44.41.66.49.82,1,1.69,1.47,2.58.58,1,1.14,2.15,1.7,3.29.19.38.37.77.57,1.17l.59,1.26a233.9,233.9,0,0,1,10.57,28.57.26.26,0,0,1,0,.08c0,.1.07.19.09.28.16.51.32,1,.47,1.56a.14.14,0,0,1,0,.07c0,.1.07.19.1.29.22.74.44,1.47.65,2.21,1.33,4.49,2.61,9,3.8,13.57q1.36,5.13,2.6,10.15l.21.86.21.83a.77.77,0,0,0,.05.19c.13.57.27,1.14.41,1.72S403.78,208,403.93,208.64Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,204.78a3.69,3.69,0,0,0-.26.38,2,2,0,0,0,.31-.19A.77.77,0,0,1,403,204.78Zm-51.92,3.86h.61c.16-.22.32-.46.46-.7A10.93,10.93,0,0,0,351.09,208.64Zm-6.34-.55a2.38,2.38,0,0,0-.76.55h3.9A2.85,2.85,0,0,0,344.75,208.09ZM381,160a2.61,2.61,0,0,1-1.08.54,2.13,2.13,0,0,1-2-.62,2.77,2.77,0,0,0-4.28.48c-.26.38-.55.76-.79,1.17.43-.24.79-.52,1.19-.79a2.76,2.76,0,0,1,1.06-.57,2.14,2.14,0,0,1,2,.54,2.87,2.87,0,0,0,3.09.63,2.67,2.67,0,0,0,1.2-1c.25-.4.53-.76.77-1.18C381.72,159.48,381.34,159.76,381,160Zm-28.25-18.67c-.1-.47-.16-.93-.28-1.38-.13.45-.19.91-.29,1.38a2.63,2.63,0,0,1-.07.42,2.14,2.14,0,0,1-.28.74,2.1,2.1,0,0,1-1.8,1.05,2.88,2.88,0,0,0-2.64,1.73,2.7,2.7,0,0,0-.15,1.55c.09.45.15.92.28,1.38.13-.46.18-.93.29-1.38a2.7,2.7,0,0,1,.39-1.15,2.12,2.12,0,0,1,1.86-1,2.87,2.87,0,0,0,2.38-1.4,3.36,3.36,0,0,0,.2-.43A2.81,2.81,0,0,0,352.71,141.35Zm-21.92,47c-.09-.45-.15-.92-.28-1.38-.12.46-.18.93-.28,1.38a2.83,2.83,0,0,1-.35,1.17,2.12,2.12,0,0,1-1.8,1,2.86,2.86,0,0,0-2.63,1.73,2.71,2.71,0,0,0-.15,1.55c.09.47.15.92.28,1.38.13-.46.18-.91.28-1.38a2.61,2.61,0,0,1,.38-1.14,2.17,2.17,0,0,1,1.86-1,2.82,2.82,0,0,0,2.59-1.83A2.7,2.7,0,0,0,330.79,188.34Zm47.22-.92c-.09-.47-.15-.93-.28-1.38-.13.45-.19.91-.28,1.38a2.64,2.64,0,0,1-.35,1.16,2.13,2.13,0,0,1-1.8,1,2.87,2.87,0,0,0-2.64,1.73,2.76,2.76,0,0,0-.15,1.54c.1.46.15.93.28,1.39.13-.46.19-.93.28-1.39a2.71,2.71,0,0,1,.39-1.14,2.15,2.15,0,0,1,1.86-1,2.85,2.85,0,0,0,2.59-1.83A2.8,2.8,0,0,0,378,187.42ZM394.86,175a.26.26,0,0,0,0-.08l-.14,0-.66.15a8.81,8.81,0,0,0,.92.19C394.93,175.15,394.89,175.06,394.86,175Zm-41.49,1.95a2.37,2.37,0,0,1-1.13-.38,2.16,2.16,0,0,1-1-1.86,2.83,2.83,0,0,0-1.82-2.6,2.8,2.8,0,0,0-1.53-.11c-.46.1-.94.16-1.4.28.46.13.94.19,1.4.29a2.69,2.69,0,0,1,1.17.35,2.14,2.14,0,0,1,1,1.81,2.85,2.85,0,0,0,1.73,2.63,2.68,2.68,0,0,0,1.54.15c.47-.09.93-.15,1.38-.28C354.3,177.06,353.84,177,353.37,176.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.14,208.64H402c-.19-.8-.39-1.63-.6-2.48-.08-.38-.17-.76-.28-1.15a1.05,1.05,0,0,0-.06-.24c-.75-3-1.64-6.24-2.7-9.63-2.71-8.6-6.45-18.74-10-28-1-2.71-2.07-5.36-3.06-7.85-.24-.63-.49-1.25-.72-1.86s-.39-1-.57-1.45c-1.21-3-2.31-5.79-3.25-8.13s-1.79-4.48-2.31-5.85c-.11-.28-.21-.55-.29-.81-.85-2.61-.24-3.54,1.21-3.34a5.3,5.3,0,0,1,.6.12,8.77,8.77,0,0,1,1.26.51,18.43,18.43,0,0,1,1.92,1.07,2,2,0,0,1,.19.12l.24.15a55.16,55.16,0,0,1,9.44,8.22c6,6.52,16.49,20.6,26.35,35.77.13.19.25.36.36.55C425,192.51,430,200.92,434.14,208.64Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.82,208.64H401.23c-.22-.82-.45-1.66-.69-2.53a.35.35,0,0,1,0-.06c-.08-.29-.16-.58-.25-.89C397.45,195,394,182.87,391.87,177c-.2-.6-.44-1.2-.66-1.85-1.11-3-2.65-6.93-4.33-11.19l0,0c-.51-1.3-1-2.62-1.57-4-.23-.57-.46-1.15-.68-1.73s-.38-.92-.56-1.37l-.09-.21h0c-1.17-2.91-2.32-5.77-3.39-8.39-1-2.41-1.88-4.62-2.65-6.48l-2.34-5.72a22,22,0,0,1,3.76.94,1.69,1.69,0,0,1,.27.1c.49.17,1,.36,1.48.58q1,.43,2.07,1c3.82,2.09,8.15,5.6,13.78,11.51,4.28,4.51,14.63,17.58,24.67,32.69.41.59.81,1.2,1.2,1.82A247.27,247.27,0,0,1,436.82,208.64Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.6,182.94a2.59,2.59,0,0,0-1.38.23,3.16,3.16,0,0,0-1.16,1c-.26.4-.55.76-.78,1.17.42-.23.78-.52,1.17-.77l.24-.19a2.44,2.44,0,0,1,.83-.4,2.19,2.19,0,0,1,2,.54,1.71,1.71,0,0,0,.25.22C422.41,184.14,422,183.53,421.6,182.94Zm-12.74,20.75a2.53,2.53,0,0,1-1.08.53,2.15,2.15,0,0,1-2-.61,2.63,2.63,0,0,0-1.26-.7,2.7,2.7,0,0,0-1.86.15l-.06,0a2.8,2.8,0,0,0-1.1,1c-.15.23-.32.45-.47.69a2.71,2.71,0,0,0-.31.49,2.68,2.68,0,0,0,.37-.25c.27-.17.53-.36.81-.54a2.42,2.42,0,0,1,.91-.52.38.38,0,0,1,.15,0,2.11,2.11,0,0,1,2,.53,2.62,2.62,0,0,0,.35.3,2.82,2.82,0,0,0,2.73.34,2.76,2.76,0,0,0,1.2-1c.25-.39.54-.75.78-1.17C409.62,203.14,409.26,203.42,408.86,203.69Zm-10-23.89a2.27,2.27,0,0,1-1.14-.38,2.13,2.13,0,0,1-1-1.85,2.84,2.84,0,0,0-1.83-2.6h0l-.17-.06a2.86,2.86,0,0,0-1.33,0c-.46.09-.93.14-1.38.27.45.12.92.18,1.38.28a2.83,2.83,0,0,1,1.17.35,2.25,2.25,0,0,1,.89,1,.14.14,0,0,1,0,.07,1.42,1.42,0,0,1,.1.29,2,2,0,0,1,0,.42,2.83,2.83,0,0,0,.61,1.79,2.55,2.55,0,0,0,1.11.84,2.71,2.71,0,0,0,1.55.15c.46-.09.92-.15,1.39-.28C399.77,180,399.31,179.9,398.85,179.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.1,208.64h-5.87c-.22-.82-.45-1.66-.69-2.53a.35.35,0,0,1,0-.06c-.08-.29-.16-.58-.25-.89C397.45,195,394,182.87,391.87,177c-.2-.6-.44-1.2-.66-1.85-1.11-3-2.65-6.93-4.33-11.19l1.44,3.18L400,192.94l4.52,10,.82,1.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.4,143.31c.39,3.41-.68,9.09-2.43,15-1,3.29-2.31,7.33-3.81,11.75-1.75,5.11-3.76,10.74-5.78,16.31-1.86,5.12-5.42,14.68-8.24,22.26H298c1.6-3.08,3.32-6.22,5.14-9.37.13-.25.28-.5.43-.75a345.22,345.22,0,0,1,22.35-33.72c.24-.3.47-.6.69-.91,7.22-9.5,14-17.23,19-21.45a11.65,11.65,0,0,1,3.27-2.12c1.71-.66,2.75,0,3.25,1.45A6,6,0,0,1,352.4,143.31Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,144c-.05.14-.08.28-.13.42-1.26,4.15-3.23,9.19-4.6,13.49-1.65,5.2-4.7,13.74-8,22.84-3.61,9.82-7.57,20.29-10.48,27.94H296.32c1.71-3.19,3.54-6.45,5.46-9.7l.29-.49a387.3,387.3,0,0,1,23-34.25l.7-.93c3.83-5.05,7.42-9.47,10.47-12.94,5.27-5.94,11.08-10.82,15.15-13.06a15.49,15.49,0,0,1,1.46-.74c1.45-.62,2.56-.78,3.19-.4a1.47,1.47,0,0,1,.55.67,4.53,4.53,0,0,1,.23,2.26,24.78,24.78,0,0,1-.91,4.37C355.85,143.6,355.79,143.77,355.75,144Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,208.64h-4.88c.27-.09.53-.16.78-.23l.05,0a15.69,15.69,0,0,1,3.5-.67h0l.09.15.14.22Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.06,163.54a2.58,2.58,0,0,1-1.07.54,2.14,2.14,0,0,1-1.42-.19,1.63,1.63,0,0,1-.59-.43l-.22-.19-.7.93a.47.47,0,0,1,.12.09,2.22,2.22,0,0,0,.7.51,2.79,2.79,0,0,0,2.39.12,2.7,2.7,0,0,0,1.19-1c.26-.4.54-.76.77-1.18C329.82,163,329.45,163.28,329.06,163.54Zm23.65-22.19c-.1-.47-.16-.93-.28-1.38-.13.45-.19.91-.29,1.38a2.63,2.63,0,0,1-.07.42,2.14,2.14,0,0,1-.28.74,2.1,2.1,0,0,1-1.8,1.05,2.88,2.88,0,0,0-2.64,1.73,2.7,2.7,0,0,0-.15,1.55c.09.45.15.92.28,1.38.13-.46.18-.93.29-1.38a2.7,2.7,0,0,1,.39-1.15,2.12,2.12,0,0,1,1.86-1,2.87,2.87,0,0,0,2.38-1.4,3.36,3.36,0,0,0,.2-.43A2.81,2.81,0,0,0,352.71,141.35Zm-21.92,47c-.09-.45-.15-.92-.28-1.38-.12.46-.18.93-.28,1.38a2.83,2.83,0,0,1-.35,1.17,2.12,2.12,0,0,1-1.8,1,2.86,2.86,0,0,0-2.63,1.73,2.71,2.71,0,0,0-.15,1.55c.09.47.15.92.28,1.38.13-.46.18-.91.28-1.38a2.61,2.61,0,0,1,.38-1.14,2.17,2.17,0,0,1,1.86-1,2.82,2.82,0,0,0,2.59-1.83A2.7,2.7,0,0,0,330.79,188.34Zm-23.18,15a2.66,2.66,0,0,1-1.15-.39,2.2,2.2,0,0,1-1-1.86,2.78,2.78,0,0,0-1.82-2.58.28.28,0,0,0-.12,0,2.82,2.82,0,0,0-1.43-.07h0l-.29.49.32.07a2.62,2.62,0,0,1,1,.26,1.51,1.51,0,0,1,.18.09,2.16,2.16,0,0,1,1.05,1.8,2.86,2.86,0,0,0,1.73,2.64,2.79,2.79,0,0,0,1.55.15c.45-.1.91-.15,1.38-.28C308.52,203.54,308.06,203.48,307.61,203.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.91,176.2c-.69,1.54-1.38,3.1-2.2,4.58-.57,1-1.18,2-1.79,3q-2.88,8.58-6,17.07c-1,2.59-1.92,5.18-2.91,7.77h-1.37c4.54-12.9,9.19-25.78,14.22-38.51a.19.19,0,0,1,.3-.06.18.18,0,0,1,.08.19c-1,3.49-2.13,7-3.27,10.44l.11-.21c.77-1.53,1.67-3,2.57-4.42A.15.15,0,0,1,345.91,176.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.74,151.22c-5.54,2-16.3-5.6-21-12.21-.32-.46-.15-5.64-.25-11.94-.08-3.82-.25-8.08-.69-11.95l25,3.14s-1.47,8.39-.66,15.14a8.38,8.38,0,0,0,.35,1.57c0,.07,0,.16.06.26C381.39,138.19,383.1,149.29,377.74,151.22Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.56,135.23a4.79,4.79,0,0,1,.13.54c-14.95-.63-20.63-7.2-24.31-13.51-.11-2.4-.27-4.83-.55-7.14l25,3.14s-1.48,8.39-.66,15.14a8.56,8.56,0,0,0,.35,1.57C380.51,135,380.53,135.13,380.56,135.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.54,74.05s8,3.12,9.58,11.11-.05,16.45-.74,16.87S380.54,74.05,380.54,74.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.47,86.62c-2.35,8.75,3.1,33.62,9.45,39,9.22,7.78,23.87,8,30.37-2.93,6.3-10.64-1.37-42.93-8.43-47.76C370.47,67.8,352.93,73.68,349.47,86.62Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,100.53c0-.06-.12.11-.1.18.41,1.66.6,3.64-.8,4.52,0,0,0,.11,0,.09C372.91,104.66,372.63,102,372,100.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,99.1c-2.74.37-1.79,5.83.75,5.48S372.4,98.79,370.1,99.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.49,98.28c0-.07.14,0,.15.12.24,1.7.8,3.61,2.43,3.9.05,0,.06.1,0,.1C382.16,102.46,381.44,99.92,381.49,98.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,96.25c2.68-.68,3.84,4.74,1.35,5.36S380.44,96.82,382.69,96.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.2,95.62c.71-.32,1.31-.73,2-1.11A3.76,3.76,0,0,0,371,93a1.18,1.18,0,0,0-.43-1.36,2.87,2.87,0,0,0-2.93.2,4.27,4.27,0,0,0-2.11,2.24A1.25,1.25,0,0,0,367.2,95.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.17,93.51a19.12,19.12,0,0,1-2.27-.19,3.61,3.61,0,0,1-2.27-.63,1.16,1.16,0,0,1-.18-1.41,2.91,2.91,0,0,1,2.76-1,4.28,4.28,0,0,1,2.84,1.16A1.25,1.25,0,0,1,384.17,93.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.28,115.56c.48.32,1,.8,1.6.74a4.54,4.54,0,0,0,1.74-.74.06.06,0,0,1,.09.08,2.3,2.3,0,0,1-2,1.28,1.82,1.82,0,0,1-1.59-1.26C373.09,115.57,373.21,115.51,373.28,115.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,110.19a5.84,5.84,0,0,0,4.29,1.89,7.37,7.37,0,0,0,2.08-.26,2.22,2.22,0,0,0,.39-.11l.36-.12a.44.44,0,0,0,.27-.44h0a.48.48,0,0,0-.05-.17v0l0-.14c-.19-1.31-.66-3.27-.66-3.27.52.16,3.13.83,3,.15-1.31-5.56-2.77-11.75-5.25-17a.16.16,0,0,0-.3.1c1.05,5.4,3,10.58,4.18,16a10.32,10.32,0,0,0-2.86-.36c-.18.09,1,3.77,1,4.36v.07c-2.14.66-3.9.28-6.28-.82C374.17,109.94,374.06,110.07,374.18,110.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.65,109.75c5.05-.84.77-23.11.77-23.11s5.56,1.57,9.86,1.16a45.13,45.13,0,0,0,9.83-2.15c.68-.32-8.7-2.3-8.7-2.3s22.74.46,23.22-3.84C388.8,78,383.71,64.89,365,67c-13.87,1.57-19.29,16.45-19.29,16.45s-6.22,8-4.84,11.28C343.24,100.46,348.29,110.64,353.65,109.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.52,106.94s-6.1-7.78-9.66-5.56,1.34,13.71,5.73,15.07a4.38,4.38,0,0,0,5.74-2.67Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.34,104.64c-.07,0-.07.09,0,.12,3.09,1,4.83,3.77,6.1,6.61-1-1.07-2.21-1.61-3.65-.46-.08.06,0,.18.09.15a2.7,2.7,0,0,1,3,.78,12.91,12.91,0,0,1,1.56,2.32c.15.27.63.09.51-.21l0-.07C355.79,110,352.5,104.8,348.34,104.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.48,134.7l-5.31,14.69-18.58-17.53-4.85,6s18.6,28.28,18.66,27l5.46-12.63,8.89,8.31-1.52-21.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.61,149.78c-.37-3.56-.65-7.16-1.18-10.71,0-.12-.22-.17-.25,0-.58,3.48.91,17.11,1,20.38l0,0c-.37-.36-8.23-7.3-8.3-7.18-1.21,2-5.22,11.22-5.49,12.05-2.94-4.49-14.18-20.79-17.62-25a.13.13,0,0,0-.21.14c2.63,4.76,17.52,26.73,17.73,26.65A140.27,140.27,0,0,0,376,152.69c1.34,1.52,9.3,9.38,9.31,8.85A112.76,112.76,0,0,0,384.61,149.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.39,294.21c18,37.39,58.1,85.79,74.49,85.85,7.8,0,21.74,1.75,31.88-7.31,22.14-19.77,37-51.83,45.6-75.51,2.63-7.28-42.75-27.62-46.78-20.39-10.57,18.95-23.4,42.89-25.67,42.74C463.52,319,430.45,292,407.37,273,379.34,250,385.21,279.3,392.39,294.21Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.08,255.83c5.35-6.5,11-14.38,18.61-18.78s19.92,1.79,21.63,4.65,9.59,22.38,2,26.93-11.23-11.88-12.46-13.28-2.72-3.23-4.06-2.22S509.68,281,509.68,281Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.19,256.58c.43-.26,15.87-20.42,23.51-24.83s19.91,1.8,21.63,4.65,9.59,22.39,2,26.93-11.23-11.88-12.46-13.27-2.72-3.23-4-2.23-19.16,27.85-19.16,27.85Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.22,263.92c-1.65-.63-2.89-2.33-3.94-3.71a18.07,18.07,0,0,1-2.63-5,30.54,30.54,0,0,0-1.58-4.7,9.69,9.69,0,0,0-3.46-3.36c-1.22-.71-2.11.32-2.86,1.23a44.49,44.49,0,0,0-3,4.33c-1,1.58-2,3.19-3,4.79a46.41,46.41,0,0,0-2.94,5.05c-.06.13.12.27.22.15a45.09,45.09,0,0,0,2.79-4q1.54-2.3,3.13-4.58c1-1.41,1.91-2.88,2.92-4.28.36-.5,1-1.59,1.64-1.8s1.79,1,2.19,1.41a8.31,8.31,0,0,1,2.2,4.24,24.66,24.66,0,0,0,1.71,4.62,13.07,13.07,0,0,0,2.68,3.74,18.48,18.48,0,0,0,3.76,2.17C548.26,264.3,548.41,264,548.22,263.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.16,290.83s9.45-31.68,11.53-38.09c4.17-12.87,31.94-50.07,36.74-53.7s13,5.77-5.42,31.74c-9.71,13.69-7.51,22.64-4.74,26.67s11.44,9.43,18.36,5S553.93,245,559.71,240s8.63,9.39,8.19,19-5.32,20.21-10,26.15-18.65,25.38-18.65,25.38Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.38,252.26c-1.41,3.64-2.81,8.1-6.22,10.33s-7.27,1.38-10.71-.55-6.48-4.73-7.7-8.62a19.1,19.1,0,0,1,.08-10.78,46.11,46.11,0,0,1,5.71-12.08c.1-.17-.16-.31-.28-.14-2.37,3.39-10,13.57-6.61,23.67,1.36,4.13,4.4,6.71,7.92,8.73,3.24,1.86,7.13,3.2,10.71,1.42,4.36-2.16,5.9-7.69,7.37-12C554.71,252,554.45,252.07,554.38,252.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.3,309.64S513.48,369.86,495.91,377s-28.15,5.66-34.72,4.73c-1.93-.27-4.29-1.43-7-3.29-17.91-12.52-50.17-57.14-63.33-82.26-9.87-18.88-8.95-36.07,5.8-30.68,3.67,1.33,8.2,4.07,13.64,8.55,27.24,22.39,58.82,43.67,60.3,42.88s16.81-25.55,16.81-25.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22,378.4c-17.91-12.52-50.17-57.14-63.33-82.26-9.87-18.88-8.95-36.07,5.8-30.68C404.34,280.29,437.74,345.22,454.22,378.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.89,320.62c-2-1.1-21.13-8.32-25.31-9.81s-21.23-7.7-25.67-8.87a.16.16,0,0,0-.11.3c4.14,2,21.31,8.3,25.54,9.89s23.28,8.34,25.47,8.79C536,321,536,320.7,535.89,320.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.75,439.33c-2.12,2.32-139.49,2.05-140.19,1.2-1.92-2.33,31.61-144.85,62.56-169.55,6.65-5.32,32.11-4.42,35.6-3.05,3.95,1.54,15.1,20.54,20.16,36C427,334.87,440.59,437.29,438.75,439.33Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.75,439.33c-2.12,2.32-139.49,2.05-140.19,1.2-1.92-2.33,31.61-144.85,62.56-169.55,6.65-5.32,32.11-4.42,35.6-3.05,3.95,1.54,15.1,20.54,20.16,36C427,334.87,440.59,437.29,438.75,439.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.68 300.75 392.09 289.49 400.28 298.5 398.24 307.42 390.11 308.44 385.68 300.75",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.11 308.44 385.91 399.71 402.92 429.95 411.92 396.01 398.24 307.42 390.11 308.44",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.82,455.7H288.88c-.75-.52,7.24-30.53,8.35-34.73,8.62-33.2,32.89-114.11,55.84-142,.78-1,10.63-11.73,10.63-11.73L400.86,359c0-.77,5.65-21.49,6.07-43.13.15-7.78-4.56-41.77-4.56-41.77,2.13,2.83,14.47,20.34,22.87,56.38C433.78,367.18,450.79,455.18,450.82,455.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.86,359q1.29,12,2.18,24.12c.63,8,1.14,16.1,1.62,24.15s.88,16.11,1.18,24.18.55,16.13.63,24.21q-1.29-12-2.18-24.12c-.63-8.05-1.14-16.1-1.62-24.15s-.87-16.12-1.18-24.18S400.94,367.12,400.86,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.13,378.34a4,4,0,1,1-4.15-3.75A4,4,0,0,1,397.13,378.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.7,405.83a4,4,0,1,1-4.15-3.75A4,4,0,0,1,398.7,405.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.27,433.32a4,4,0,1,1-4.15-3.75A3.95,3.95,0,0,1,400.27,433.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.54,290.24c-7.09,42.25-19.24,70.47-28,89.67-6.43,14-30.24,53-37.59,61.52-7.52,8.71-58-18.1-54.87-24.76,3.2-6.82,44.11-50.28,50.23-61.18,3.72-6.63,33.55-47.83,51.69-73.2C355,266.81,367.6,260.16,362.54,290.24Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.86,438.12c-1,8.93-6.69,27-11.13,29.81s-28.09,2.73-40,3-14.32-3-14.21-7.13,25.09-5.4,25.09-5.4-33.18,10.26-41.54,12-27.61,7-30.55.11c-1.32-3.11,3.91-6.39,3.91-6.39s-8.07,2.53-9.44-1.48c-1.57-4.56,4.83-7.22,4.83-7.22s-5,1.13-5.24-2.61c-.44-8.36,31.22-13.12,31.22-13.12s-24.06,12.33-25,5.52c-1.28-9.42,48.32-20.81,53.42-25a96.7,96.7,0,0,0,10.34-10.47Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74,465.85a3.66,3.66,0,0,1,1.07-3.21,10.2,10.2,0,0,1,2.86-1.95,39.63,39.63,0,0,1,6.78-2.35c4.67-1.29,9.46-2.23,14.23-3.57a58.3,58.3,0,0,0-14.67,2,27.09,27.09,0,0,0-7,2.83,9.69,9.69,0,0,0-2.88,2.58A3.83,3.83,0,0,0,231.74,465.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.43,464.08c3.41-.91,6.78-1.95,10.14-3s6.69-2.15,10-3.23l10-3.36c3.33-1.12,6.66-2.23,10-3.31a78,78,0,0,0-10.39,2.08c-3.43.85-6.8,1.91-10.15,3s-6.67,2.29-9.94,3.61S191.6,462.52,188.43,464.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.38,443a68,68,0,0,0-9.6,1.53,89.79,89.79,0,0,0-9.37,2.62,85.84,85.84,0,0,0-9,3.59,69.12,69.12,0,0,0-8.55,4.63c3.05-1.12,6-2.36,9-3.44s6-2.2,9.09-3.2,6.1-2,9.16-3S217.27,443.92,220.38,443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,435.14a59.45,59.45,0,0,0-15.26,3.56,58.74,58.74,0,0,0-14,7.12c4.9-1.86,9.66-3.82,14.53-5.56S210.36,436.85,215.31,435.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.42,452.15l-62.48-37.61s48.37-52.94,51.47-57.72,38.81-53.71,50.49-71.66c13.19-20.29,31.07-29.85,23.48,5.2-10.63,49.12-23.31,83.6-27.78,95.35S300.42,452.15,300.42,452.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,436.75a65.18,65.18,0,0,0-6.57-4.11c-2-1.22-3.91-2.46-5.89-3.65-4.32-2.6-8.63-5.22-13-7.8s-8.63-5.16-13-7.69-8.58-5.18-13-7.45c-.17-.09-.32.16-.17.28,3.93,3.1,8.19,5.8,12.38,8.55s8.33,5.29,12.57,7.82,8.7,5,13.1,7.46c2.12,1.17,4.29,2.26,6.45,3.36a60.16,60.16,0,0,0,7,3.45A.13.13,0,0,0,301.81,436.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.65,448.68l5.86,3.31-.26.07,17.64-34.18c5.9-11.37,11.84-22.75,17.25-34.32,2.8-5.7,4.66-11.79,6.66-17.89l5.78-18.33L353.31,329l5.82-18.34c-1.56,6.22-3.25,12.41-4.9,18.61L349,347.78c-1.73,6.17-3.6,12.31-5.51,18.44q-1.42,4.59-3,9.17a85.55,85.55,0,0,1-3.62,9c-5.51,11.63-11.55,22.94-17.59,34.25S307,441.14,300.58,452.24l-.1.17-.16-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.5,323.16a26,26,0,0,1,2-4.25c.4-.66.79-1.33,1.22-2l1.29-2a7.35,7.35,0,0,1-.6,2.32,16.2,16.2,0,0,1-1.05,2.13A15.9,15.9,0,0,1,355.5,323.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.47 263.6 363.99 301.38 363.82 301.1 377.4 307.26 377.75 307.42 377.57 307.76 370.98 320.19 370.94 319.72 401.25 358.74 400.39 358.91 412.92 314.91 412.96 315.21 406.2 304.08 406.05 303.83 406.28 303.66 412.89 298.75 412.81 299.07 399.42 265.92 413.31 298.86 413.4 299.06 413.23 299.19 406.65 304.16 406.73 303.75 413.61 314.81 413.69 314.95 413.65 315.11 401.33 359.17 401.07 360.11 400.48 359.34 370.26 320.25 370.09 320.02 370.22 319.78 376.92 307.42 377.09 307.93 363.57 301.63 363.39 301.54 363.4 301.35 365.47 263.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.12,287.89C388.4,291,373,281.69,366,272.61c-.47-.62-.53-8-1-16.86-.33-5.4-.81-11.41-1.66-16.86-.17-1.12,35.47,3,35.47,3s-1.6,11.94-.07,21.43a11.06,11.06,0,0,0,.58,2.2c0,.11.07.23.1.37C400.77,270.06,403.58,284.86,396.12,287.89Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.47,238.71c3,9,12.17,30.34,30.48,27.94a20.23,20.23,0,0,0,3.46-.73,1.64,1.64,0,0,0-.1-.37,13.72,13.72,0,0,1-.58-2.19c-1.53-9.51.08-21.45.08-21.45S373.1,238.92,365.47,238.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.49,199.15c-1.73,12.71,10.32,46.65,20.19,53,14.32,9.28,34.93,7.06,42.1-9.5,7-16-9.53-60-20.3-65.53C378.63,169,355.05,180.39,352.49,199.15Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.76,188.5v.05a2.44,2.44,0,0,0-.14-.28C403.66,188.33,403.7,188.42,403.76,188.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.25,229.67a9.62,9.62,0,0,1-3,3.84,4.31,4.31,0,0,1-2.5.81c-2,0-2.44-1.69-2.48-3.22a10.27,10.27,0,0,1,.26-2.42A12.51,12.51,0,0,0,401.25,229.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.26,233.51a4.31,4.31,0,0,1-2.5.81c-2,0-2.44-1.69-2.48-3.22C395.31,230.8,397.6,231.64,398.26,233.51Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,215c0-.08-.14.17-.1.27.86,2.26,1.46,5-.35,6.48-.06.05,0,.16.06.13C392.32,220.69,391.48,217.05,390.3,215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.43,213.35c-3.79,1-1.53,8.49,2,7.57S390.6,212.52,387.43,213.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.29,210.78c0-.1.21.05.24.15.62,2.34,1.73,4.92,4.07,5.06.07,0,.1.13,0,.14C404.94,216.54,403.5,213.1,403.29,210.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.63,207.73c3.65-1.41,6.2,6,2.82,7.3S401.57,208.91,404.63,207.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.81,209.9a30.29,30.29,0,0,0,2.65-1.82c1-.71,1.89-1.17,2.35-2.37a1.65,1.65,0,0,0-.78-1.87c-1.4-.7-2.85-.14-4.1.67a6,6,0,0,0-2.68,3.42A1.76,1.76,0,0,0,383.81,209.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.88,203a28.59,28.59,0,0,1-3.2.28,5.17,5.17,0,0,1-3.32-.33,1.68,1.68,0,0,1-.59-1.94c.64-1.43,2.12-1.92,3.6-2.1a6,6,0,0,1,4.24.94A1.77,1.77,0,0,1,406.88,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.07,236.42a3.69,3.69,0,0,0,2.37.78,6.52,6.52,0,0,0,2.32-1.34.09.09,0,0,1,.14.09,3.3,3.3,0,0,1-2.57,2.15,2.59,2.59,0,0,1-2.45-1.51C392.8,236.47,393,236.37,393.07,236.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.42,228.73a8.25,8.25,0,0,0,6.34,1.93,10.47,10.47,0,0,0,2.89-.72,3,3,0,0,0,.52-.23l.49-.23a.6.6,0,0,0,.31-.66v0a2.18,2.18,0,0,0-.09-.23v0l-.06-.2c-.49-1.8-1.49-4.47-1.49-4.47.76.13,4.54.63,4.21-.29-2.79-7.6-5.9-16.05-10.28-23a.22.22,0,0,0-.4.19c2.39,7.4,6.07,14.34,8.59,21.74a14.66,14.66,0,0,0-4.08,0c-.23.15,2,5.13,2.17,6a.31.31,0,0,1,0,.09c-2.89,1.28-5.43,1.06-8.95-.08C393.36,228.38,393.23,228.59,393.42,228.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,230.66c9.36-1.66,11.42-13.83,7.06-22.12,0,0,25.27-2.87,21.54-22.8a19.86,19.86,0,0,0,18.1,4.84l4.55,6.55c2.32-1.35,3.21-9.15-4.33-13.21,0,0-2.87-9.68-11.55-13.75a13.79,13.79,0,0,0-14.89,1.58,20.87,20.87,0,0,0-15.66.06c-8.72,3.4-10.38,12.55-10.38,12.55s-11.54,5.35-11.45,14.47a18.41,18.41,0,0,0,6,13.78s-2.19,4.14,1.19,11.1C348.6,228.19,353.46,231.15,356.27,230.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.89,184.13a23.71,23.71,0,0,1,1.25,4.78,19.39,19.39,0,0,1,.27,4.86,12.72,12.72,0,0,1-3.9,8.47c-2.21,2.35-5.41,3.43-8.45,4.52-1.59.35-3.18.81-4.81,1.07s-3.27.44-4.92.71c1.66,0,3.32-.09,5-.14s3.3-.52,5-.77c3.2-.94,6.54-2.07,9-4.55a13.35,13.35,0,0,0,4-9.26A20.24,20.24,0,0,0,383.89,184.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.34,192.33a26.22,26.22,0,0,1-8.42-2.14,15.91,15.91,0,0,1-3.61-2.27,19.43,19.43,0,0,1-3-3.2,10.72,10.72,0,0,0,2.37,3.85,11.72,11.72,0,0,0,3.74,2.68,14.44,14.44,0,0,0,4.4,1.23A13.66,13.66,0,0,0,399.34,192.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.84,226.71s-9.94-9.83-14.54-6.09,4.31,19,10.72,20.14A6.2,6.2,0,0,0,370.6,236Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,224.93c-.1,0-.09.15,0,.17,4.52.94,7.45,4.44,9.74,8.2-1.54-1.33-3.4-1.87-5.21,0-.1.1,0,.25.15.2a3.82,3.82,0,0,1,4.37.56,17.93,17.93,0,0,1,2.59,3c.27.34.91,0,.69-.39l-.05-.09C366.36,231.17,360.82,224.42,355,224.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.78,263.64l-7.8,20.6-25.91-25.35-7,8.44s25.66,40.59,25.78,38.73l8.07-17.78,12.41,12-1.61-30.75Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.78,263.64l-7.8,20.6-25.91-25.35-7,8.44s25.66,40.59,25.78,38.73l8.07-17.78,12.41,12-1.61-30.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.36,285c-.43-5.06-.73-10.18-1.4-15.22,0-.18-.3-.26-.34,0-.92,4.92.85,24.29.92,28.94l-.06-.05c-.52-.52-11.48-10.56-11.59-10.39-1.77,2.83-7.69,15.78-8.09,17-4.06-6.45-21.25-31.84-26-37.92a.18.18,0,0,0-.3.18c3.61,6.82,25.84,40.34,26.14,40.25.21.15,7.58-15.8,8.44-18.8,1.86,2.19,13,13.55,13,12.79A158,158,0,0,0,404.36,285Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.14,
    y: 264.05,
    width: 150.53,
    height: 150.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,415.57H66.14V263H218.66Zm-150.52-2H216.66V265H68.14Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.66,
    cy: 264.05,
    r: 18.64,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.5 274.86 207.36 266.61 210.09 263.91 214.85 268.73 224.73 253.24 227.97 255.3 215.5 274.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.42,278.55s-13-7.19-24.58,0-17.07,24.93-15.09,39.81S95.6,343.07,94.29,354.12s5.94,16.17,8.38,22c2.79,6.64-8.38,30.23,20,35.7,35.56,6.85,49.16-15,45.53-33.1-1.77-8.86-6.76-15.15-6.66-22.32s5.15-12.87,2.51-22-6.14-7.85-7.59-22.11S158,281,145.42,278.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,278.21a44.13,44.13,0,0,0-16.82,20.23,40.88,40.88,0,0,0-3,12.94c-.36,5.82.53,11.26-1.64,16.9-3.46,9-10.39,16.58-10.06,26.64A24.9,24.9,0,0,0,96,368.06c3.08,4.54,7.45,8.13,10,13a.18.18,0,0,0,.32-.17c-2.14-4.33-5.62-7.64-8.51-11.51a25.27,25.27,0,0,1-5.25-15.82c.27-9.57,7.11-16.93,10.3-25.65,1.44-4,1.54-7.77,1.41-11.91a43.38,43.38,0,0,1,1.84-14.39,46.55,46.55,0,0,1,17.23-23.28C123.47,278.28,123.37,278.16,123.3,278.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.34,386.88s0,.06,0,.06A0,0,0,1,0,108.34,386.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.12,376.13c-.89-4.28-3.13-8.16-4-12.42-1.07-5.13.22-10.25,1.2-15.28,1.4-7.19,1.24-14-1.93-20.75-2.06-4.38-4.56-8.47-6.08-13.08a53.59,53.59,0,0,1-2.71-15.45c0-.11-.19-.11-.19,0a49.26,49.26,0,0,0,4.76,22c1.93,4,4.35,7.84,5.46,12.2,1.34,5.25.82,10.31-.1,15.57a59.65,59.65,0,0,0-1.32,10.63c0,3.72,1.2,7,2.52,10.47a36.85,36.85,0,0,1-.16,27.13c-.06.15.21.27.28.11A34.93,34.93,0,0,0,168.12,376.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.33,352.84c.32-7.88,5.81-13.23,9.14-20.06,2.52-5.16,4.23-10.67,3.4-16.36,0-.09-.18-.07-.18,0,.43,8.23-3,15.7-7.58,22.59-3,4.58-5.54,9-5.56,14.51s2.13,9.95,5.21,14.42c2.19,3.19,4.35,6.16,5.28,9.93s.71,7.68.53,11.49c0,.2.31.19.33,0,.52-5.91.61-11.63-2.36-17C97.89,365.74,93,360.85,93.33,352.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.49,370.53A49.13,49.13,0,0,0,165,362.9c-3-4.43-3.52-8-2.51-13.29a.1.1,0,0,0-.2-.05c-1.45,4.34-1.79,7.94.78,11.93,3.58,5.57,7.1,10.64,7.83,17.29,1.31,11.81-5.35,22.81-16.16,28.78-.15.09,0,.3.14.23,9.07-4.47,15.43-12.55,16.75-22.08A28.19,28.19,0,0,0,169.49,370.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.72,414.57H173.6c-4.57-11.51-13.3-32.33-20.42-48.81-5.75-13.31-3.2-15.7,1.25-14.17,3.41,1.19,7.94,4.66,10.73,7.32C179.73,372.76,196.63,395.37,207.72,414.57Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.42,414.57H173c-5.85-14-17.19-40.74-21.15-50.91-3.45-8.87-2.76-13.79,2.13-12.7,2.55.56,6.25,2.76,11.1,6.89C175.84,367.07,196.76,393,209.42,414.57Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,346.24c.47,1.63,8.92,11.92,16.44,11.16,2.45-.25,1.68-13.68,1.68-13.68l.17-1,2.37-14.06-16.88-9.61-2.43-1.26s-.4,3.89-.84,8.74q0,.33-.06.69c0,.27-.07.53-.08.79-.08.72-.15,1.46-.21,2.2-.05.56-.1,1.1-.12,1.69s-.08,1.17-.12,1.77A91.42,91.42,0,0,0,130.08,346.24Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.59,326.53a28.61,28.61,0,0,0,17.78,16.19l2.37-14.06-16.88-9.61-2.43-1.26S131,321.68,130.59,326.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,303.89c5.09,24.51-9,30.32-14.3,31.41-4.8,1-21.26,3.75-28.85-20.09s2.2-34,13-36.81S163.28,279.39,168.36,303.89Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,299.37c-.59,0-1.14-.09-1.72-.14a2.83,2.83,0,0,1-1.73-.47.89.89,0,0,1-.14-1.08,2.21,2.21,0,0,1,2.09-.79,3.23,3.23,0,0,1,2.17.87A1,1,0,0,1,162.52,299.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,302.36a15.73,15.73,0,0,0,1.63-.57,2.87,2.87,0,0,0,1.55-.9.89.89,0,0,0-.14-1.08,2.2,2.2,0,0,0-2.22-.23,3.18,3.18,0,0,0-1.87,1.4A1,1,0,0,0,145.4,302.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,307.82c0-.06-.12.1-.1.17.31,1.68.39,3.65-1.05,4.44,0,0,0,.11,0,.1C150.23,312,150.1,309.36,149.53,307.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.76,306.3c-2.74.21-2.12,5.67.42,5.48S150.06,306.12,147.76,306.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.72,306.71c-.44.36-.85,1-1.42,1.08s-1.22-.37-1.72-.87c-.05-.05-.09,0-.09.07.11,1.05.63,2.08,1.77,2.11s1.67-1,1.81-2.07C147.1,306.83,146.9,306.56,146.72,306.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,306c0-.07.14.06.14.13.13,1.7.56,3.63,2.15,4,.05,0,.06.1,0,.09C160.45,310.17,159.9,307.61,160.06,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.38,304.05c2.7-.5,3.5,4.94,1,5.4S159.12,304.46,161.38,304.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.57,304.24c.47.22,1,.69,1.49.64s1-.7,1.25-1.32c0-.06.09,0,.1.05.18,1,0,2.17-1,2.52s-1.68-.48-2.08-1.48C162.27,304.46,162.38,304.15,162.57,304.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,320.91c.43.37.88.89,1.5.9a4.5,4.5,0,0,0,1.8-.56.06.06,0,0,1,.08.09,2.32,2.32,0,0,1-2.1,1.07,1.82,1.82,0,0,1-1.44-1.41C151.5,320.9,151.63,320.85,151.69,320.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,313.9s.66,2.48.81,3.68c0,.11-.26.2-.67.27,0,0,0,0,0,0a5.74,5.74,0,0,1-5.77-1.42.13.13,0,0,1,.16-.19,8.59,8.59,0,0,0,5.36.83c0-.34-1.29-4.21-1.1-4.25a10.29,10.29,0,0,1,2.78.27c-1.24-5.21-3.31-10.17-4.47-15.38,0-.18.23-.27.3-.11,2.54,5.05,4.1,11,5.52,16.36C161.05,314.63,158.49,314.05,158,313.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,314c5.27-.73,4-12.83,4-12.83s8.7-2.81,11.61-9.33c0,0-1.79,5.55-5,8.16-.54.44,17.33-3.71,17.26-17.8,0,0,4.42,13.35,13,15.1.42.08-2.8-12.31-5.84-14.9a26.61,26.61,0,0,0-5.75-3.79,26.17,26.17,0,0,0-19.62-2.49c-10.91,3.05-16.69,15.66-16.92,20.56C118.22,306.35,123.46,314.38,126,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13,300.25c9.81-1.69,16.86-9,16.39-19.19A.23.23,0,0,1,154,281c2.65,10.06-7.45,19-16.9,19.44C136.83,300.45,136.9,300.29,137.13,300.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.91,313.47c5-3.43,5.15-8.91,4.86-14.42,0-.16.26-.2.28,0,.77,5.34.64,12-4.89,14.89A.25.25,0,0,1,125.91,313.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,280.14a.06.06,0,0,1,.11,0c1.92,5.5,3.39,15,10.81,15.5a.16.16,0,0,1,0,.31C157.34,296.09,153.58,286.08,153.59,280.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43,313.94s-6.57-6.9-9.78-4.44,2.55,13,6.89,13.94a4.23,4.23,0,0,0,5.27-3.1Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,312.49c-.06,0-.06.1,0,.11,3.06.73,5,3.18,6.47,5.79-1-.94-2.28-1.34-3.55-.11-.07.07,0,.18.1.15a2.6,2.6,0,0,1,3,.46,12.63,12.63,0,0,1,1.7,2.09c.18.24.62,0,.48-.25a.25.25,0,0,0,0-.07C129,317,125.38,312.26,121.37,312.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,402.32l0,.18c-.11.44-.23.87-.33,1.29-.16.6-.34,1.17-.52,1.72a.94.94,0,0,1,0,.09,40.83,40.83,0,0,1-3.19,7.4l.23,1.57H97c5.92-23.19,14.14-49.09,23.53-61.4q1-1.26,2-2.34l.75-.78c.54-.55,1.09-1.06,1.63-1.56,1.22-1,1.06-9.26,1.63-9.82a13.41,13.41,0,0,1,3.4.09c3.31.29,8.47.91,13,1.52,2.2.31,4.24.61,5.81.88a13.59,13.59,0,0,1,3.15.68c.29.59,1.57,8.36,1.57,8.36l.58.76c.17.2.33.41.5.63,2.38,3.12,6.06,8.12,9.85,13.67l0,0,.51.75,1,1.52c.09.14.2.29.29.45,5.89,8.78,11.56,18.35,12.68,23.77A25.07,25.07,0,0,1,178.45,402.32Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.09,409.9a57.48,57.48,0,0,0-7.48,1.35c-3.77,1-7.5,2.09-11.2,3.32h-2.53c2.94-1.1,6-2.18,7.92-2.73a52,52,0,0,1,13.27-2.21A.14.14,0,0,1,162.09,409.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,411.92a41,41,0,0,0-14,1.24c-.06,0,0,.1,0,.09,2.31-.27,4.62-.54,6.94-.74s4.67-.31,7-.46A.07.07,0,0,0,170,411.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14,347.27a17.42,17.42,0,0,1,.14-6.11,15.85,15.85,0,0,1,.2,3.06A16.56,16.56,0,0,1,129.14,347.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.19,347.73a15.74,15.74,0,0,1-.2-3.06,16.66,16.66,0,0,1,.34-3.05,15.09,15.09,0,0,1,.2,3.06A15.74,15.74,0,0,1,133.19,347.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.24,348.19a15.73,15.73,0,0,1-.19-3.06,15.08,15.08,0,0,1,.34-3.05,15.78,15.78,0,0,1,.19,3.06A15,15,0,0,1,137.24,348.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.3,348.65a17.42,17.42,0,0,1,.14-6.11,15.79,15.79,0,0,1,.2,3.06A16.56,16.56,0,0,1,141.3,348.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.35,349.11a15.74,15.74,0,0,1-.2-3.06,16.66,16.66,0,0,1,.34-3.05,15,15,0,0,1,.2,3.06A15.74,15.74,0,0,1,145.35,349.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.4,349.57a15.78,15.78,0,0,1-.19-3.06,15.08,15.08,0,0,1,.34-3.05,15.78,15.78,0,0,1,.19,3.06A15,15,0,0,1,149.4,349.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.77,401a26.92,26.92,0,0,1-1.72,6.49,25.23,25.23,0,0,1-3.11,5.69c.06.47.13,1,.2,1.42H174c-.07-.49-.15-1-.22-1.49l0-.22.16-.21a28.21,28.21,0,0,0,3.64-7,.94.94,0,0,0,0-.09c.19-.56.37-1.14.52-1.72s.23-.86.33-1.29l0-.18c.1-.5.19-1,.26-1.5a23.47,23.47,0,0,0,.06-6.43,28.11,28.11,0,0,0-1.64-6.25,80,80,0,0,0-5.8-11.74c-1.64-2.86-3.4-5.66-5.21-8.4-.09-.16-.2-.31-.29-.45l-1-1.52-.51-.75c2.21,2.83,4.28,5.79,6.24,8.8l.52.79c.27.4.52.81.78,1.21A82.3,82.3,0,0,1,178,387.8a27,27,0,0,1,1.78,6.46A24.32,24.32,0,0,1,179.77,401Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.05,367.71a11.51,11.51,0,0,1,1.15,1.78,17.57,17.57,0,0,1,.9,1.91,15,15,0,0,1,1,4.08c-.3-.64-.54-1.29-.8-1.94l-.78-1.93C169.05,370.32,168.52,369,168.05,367.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.79,363.71c-4.68,18.18-14.14,44.89-15.88,50.86H79.46c7.44-15.94,25.2-43.58,38.3-58.79a18.75,18.75,0,0,1,2.74-2.61C127.05,348,135.82,348,131.79,363.71Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,360c-.45,2.8-1.42,6.92-2.7,11.72l0,.12c-.4,1.46-.82,3-1.26,4.56-.1.35-.2.69-.29,1-3.53,12.46-8.32,27.54-11.38,37.18H77.68c7.84-16.17,24.8-43.66,39.92-60a22.19,22.19,0,0,1,5.6-4.56C129.74,346.45,134.75,350,133.14,360Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.41,371.79c-.33,1.4-.69,2.79-1.07,4.18v0c-.13.43-.24.86-.36,1.29-1.11,4-2.33,7.88-3.5,11.82l-5.29,17.33c-.79,2.7-1.64,5.45-2.29,8.14h-1.18c.65-2.93,1.57-5.66,2.41-8.47,1.81-5.77,3.64-11.52,5.58-17.25l2.89-8.58C128.55,377.44,129.57,374.64,130.41,371.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.07,373.46a8.42,8.42,0,0,1-.93,2.28,7.61,7.61,0,0,1-.69,1,3.59,3.59,0,0,1-.91.87c.36-.76.69-1.48,1.1-2.18A10.54,10.54,0,0,1,131.07,373.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,174a34.32,34.32,0,0,1-57.36,21.72l-17.18,2.52,8.6-14.85a34,34,0,0,1-2.36-16.53A34.34,34.34,0,0,1,492,174Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,174A34.61,34.61,0,0,1,485,191.44a37.8,37.8,0,0,1-3.11,3.58,39.15,39.15,0,0,1-3.62,3.07,34.78,34.78,0,0,1-17.53,6.81A33,33,0,0,1,456,205a29.21,29.21,0,0,1-4.75-.49,34.71,34.71,0,0,1-17-8.39l.41.13-17.16,2.63-1.24.19.63-1.09,8.54-14.88,0,.59A34.67,34.67,0,1,1,492,174Zm0,0a34.45,34.45,0,0,0-10.42-28.2A34.9,34.9,0,0,0,468.31,138,34.21,34.21,0,0,0,453,136.88a33.71,33.71,0,0,0-14.18,5.6,35.51,35.51,0,0,0-10.28,11.2,33.82,33.82,0,0,0-4.35,14.53,34.43,34.43,0,0,0,2.41,15l.13.31-.17.28L418,198.58l-.62-.91,17.2-2.41.23,0,.17.16a33.86,33.86,0,0,0,16.44,8.46,29.23,29.23,0,0,0,4.66.57,32.06,32.06,0,0,0,4.7,0,33.62,33.62,0,0,0,9.17-2,31.86,31.86,0,0,0,8.28-4.46,30.94,30.94,0,0,0,6.75-6.57A34.51,34.51,0,0,0,492,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.8 190.04 439.14 175.2 444.07 170.33 452.63 179 470.43 151.1 476.27 154.82 453.8 190.04",
    style: {
      fill: "#FFC727"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManager);
export default __webpack_public_path__ + "static/media/projectManager.0e6772f51ae49c2759b0cc679a9bab64.svg";
export { ForwardRef as ReactComponent };